
let dictionary_data = JSON.parse(String.raw`{
	"topics_vehicle" : [
		{
			"name" : "/ads_marker",
			"nickname" : "Marker",
			"db_table_name" : "ads_marker",
			"ROS_topic_name" : "/ads_marker",
			"ROS_data_type" : "std_msgs/String",
			"collection_rate" : "variable",
			"description" : "Collection topic for data markers manually introduced by the co-pilot. Markers relate to \"points of interest\" for later review.",
			"collected_as" : "JSON string",
			"key_words" : [ "co-pilot", "copilot", "marker", "incident", "flag" ],
			"data_table" : [{
				"name" : "timestamp",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Vehicle time (UNIX epoch)"
			},
			{
				"name" : "marker_id",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Unique ID of a marker"
			},
			{
				"name" : "marker_lat",
				"data_type" : "float64",
				"units" : "",
				"description" : "Latitude at time of keypress"
			},
			{
				"name" : "marker_long",
				"data_type" : "float64",
				"units" : "",
				"description" : "Longitude at time of keypress"
			},
			{
				"name" : "desc",
				"data_type" : "text",
				"units" : "",
				"description" : "Co-pilot's description of events associated with the given marker ID. (Added after ingestion.) "
			}]
		},
		{
			"name" : "/apollo_ros_bridge/cyberrt_ros/best_pose",
			"nickname" : "Apollo / best_pose",
			"db_table_name" : "apollo_ros_bridge-cyberrt_ros-best_pose",
			"ROS_topic_name" : "/apollo_ros_bridge/cyberrt_ros/best_pose",
			"ROS_data_type" : "novatel_oem7_msgs/BESTPOS",
			"collection_rate" : "1Hz",
			"description" : "",
			"key_words" : [ "gps", "GPS", "location", "latitude", "longitude", "position", "heading", "solution" ],
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "nov_header",
				"data_type" : [{
					"name" : "OEM7MSGTYPE",
					"data_type" : "uint16",
					"units" : "",
					"description" : "0"
				},
				{
					"name" : "message_name",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "message_id",
					"data_type" : "uint16",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "message_type",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "sequence_number",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "time_status",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "gps_week_number",
					"data_type" : "uint16",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "gps_week_milliseconds",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "sol_status",
				"data_type" : [{
					"name" : "status",
					"data_type" : "uint32",
					"units" : "",
					"description" : "0 = SOL_COMPUTED<br>1 = INSUFFICIENT_OBS<br>2 = NO_CONVERGENCE<br>3 = SINGULARITY<br>4 = COV_TRACE<br>5 = TEST_DIST<br>6 = COLD_START<br>7 = V_H_LIMIT<br>8 = VARIANCE<br>10 = RESIDUALS<br>13 = INTEGRITY_WARNING<br>18 = PENDING<br>19 = INVALID_FIX<br>20 = UNAUTHORIZED<br>22 = INVALID_RATE"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "pos_type",
				"data_type" : [{
					"name" : "type",
					"data_type" : "uint32",
					"units" : "",
					"description" : "0 = NONE<br>1 = FIXEDPOS<br>2 = FIXEDHEIGHT<br>8 = DOPPLER_VELOCITY<br>16 = SINGLE<br>17 = PSRDIFF<br>18 = WAAS<br>19 = PROPAGATED<br>32 = L1_FLOAT<br>34 = NARROW_FLOAT<br>48 = L1_INT<br>49 = WIDE_INT<br>50 = NARROW_INT<br>51 = RTK_DIRECT_INS<br>52 = INS_SBAS<br>53 = INS_PSRSP<br>54 = INS_PSRDIFF<br>55 = INS_RTKFLOAT<br>56 = INS_RTKFIXED<br>68 = PPP_CONVERGING<br>69 = PPP<br>70 = OPERATIONAL<br>71 = WARNING<br>72 = OUT_OF_BOUNDS<br>73 = INS_PPP_CONVERGING<br>74 = INS_PPP<br>77 = PPP_BASIC_CONVERGING<br>78 = PPP_BASIC<br>79 = INS_PPP_BASIC_CONVERGING<br>80 = INS_PPP_BASIC"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "lat",
				"data_type" : "float64",
				"units" : "deg",
				"description" : "Latitude"
			},
			{
				"name" : "lon",
				"data_type" : "float64",
				"units" : "deg",
				"description" : "Longitude"
			},
			{
				"name" : "hgt",
				"data_type" : "float64",
				"units" : "m",
				"description" : "Height/altitude"
			},
			{
				"name" : "undulation",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "datum_id",
				"data_type" : "uint32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "lat_stdev",
				"data_type" : "float32",
				"units" : "",
				"description" : "Latitude std deviation"
			},
			{
				"name" : "lon_stdev",
				"data_type" : "float32",
				"units" : "",
				"description" : "Longitude std deviation"
			},
			{
				"name" : "hgt_stdev",
				"data_type" : "float32",
				"units" : "",
				"description" : "Height/altitude std deviation"
			},
			{
				"name" : "stn_id",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "diff_age",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "sol_age",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "num_svs",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "num_sol_svs",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "num_sol_l1_svs",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "num_sol_multi_svs",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "reserved",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "ext_sol_stat",
				"data_type" : [{
					"name" : "status",
					"data_type" : "uint8",
					"units" : "",
					"description" : "1 = RTK_SOLUTION_VERIFIED<br>1 = PDP_SOLUTION_IS_GLIDE<br>2 = KLOBUCHAR_BROADCAST<br>4 = SBAS_BROADCAST<br>6 = MULTI_FREQUENCY_COMPUTED<br>8 = PSRDIFF_CORRECTION<br>10 = NOVATEL_BLENDED_IONO_VALUE<br>16 = RTK_ASSIST_ACTIVE<br>32 = ANTENNA_INFORMATION_IS_MISSING<br>64 = RESERVED<br>128 = POSITION_INCLUDES_TERRAIN_COMPENSATION_CORRECTIONS"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "galileo_beidou_sig_mask",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "gps_glonass_sig_mask",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/apollo_ros_bridge/cyberrt_ros/chassis",
			"nickname" : "Apollo / chassis",
			"db_table_name" : "apollo_ros_bridge-cyberrt_ros-chassis",
			"ROS_topic_name" : "/apollo_ros_bridge/cyberrt_ros/chassis",
			"ROS_data_type" : "dbw_msgs/Chassis (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "Collection topic for data reporting feedback from the vehicle platform.",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "engine_on",
				"data_type" : "bool",
				"units" : "",
				"description" : "false = ENGINE_OFF<br>true = ENGINE_ON"
			},
			{
				"name" : "drive_mode",
				"data_type" : [{
					"name" : "drive_mode",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = COMPLETE_MANUAL<br>1 = COMPLETE_AUTO_DRIVE<br>2 = AUTO_STEER_ONLY<br>3 = AUTO_SPEED_ONLY<br>4 = EMERGENCY_MODE"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "gear",
				"data_type" : [{
					"name" : "gear",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = GEAR_NEUTRAL<br>1 = GEAR_DRIVE<br>2 = GEAR_REVERSE<br>3 = GEAR_PARKING<br>4 = GEAR_LOW<br>5 = GEAR_INVALID<br>6 = GEAR_NONE"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "throttle",
				"data_type" : "float32",
				"units" : "(scale) %",
				"description" : "0.0 ~ 100.0 (pedal fully depressed)"
			},
			{
				"name" : "brake",
				"data_type" : "float32",
				"units" : "(scale) %",
				"description" : "0.0 ~ 100.0 (pedal fully depressed)"
			},
			{
				"name" : "steering_rate",
				"data_type" : "float32",
				"units" : "rad / s",
				"description" : ""
			},
			{
				"name" : "steering",
				"data_type" : "float32",
				"units" : "%",
				"description" : "(ccw:+) or (cw:-) from centered position (100% being approximate steering wheel limit)"
			},
			{
				"name" : "steering_rad",
				"data_type" : "float32",
				"units" : "rad",
				"description" : "(ccw:+) or (cw:-) from centered position"
			},
			{
				"name" : "speed",
				"data_type" : "float32",
				"units" : "m / s",
				"description" : ""
			},
			{
				"name" : "yaw_rate",
				"data_type" : "float32",
				"units" : "rad / s",
				"description" : ""
			},
			{
				"name" : "turn_signal",
				"data_type" : [{
					"name" : "turn_signal",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = TURN_NONE<br>1 = TURN_LEFT<br>2 = TURN_RIGHT"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "error_code",
				"data_type" : [{
					"name" : "error_code",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = NO_ERROR<br>1 = CMD_NOT_IN_PERIOD<br>2 = CHASSIS_ERROR<br>3 = MANUAL_INTERVENTION<br>4 = CHASSIS_CAN_NOT_IN_PERIOD<br>6 = CHASSIS_ERROR_ON_STEER<br>7 = CHASSIS_ERROR_ON_BRAKE<br>8 = CHASSIS_ERROR_ON_THROTTLE<br>9 = CHASSIS_ERROR_ON_GEAR"
				}],
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/apollo_ros_bridge/cyberrt_ros/chassis_detail",
			"nickname" : "Apollo / chassis_detail",
			"db_table_name" : "apollo_ros_bridge-cyberrt_ros-chassis_detail",
			"ROS_topic_name" : "/apollo_ros_bridge/cyberrt_ros/chassis_detail",
			"ROS_data_type" : "dbw_msgs/Chassis (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "Collection topic for data reporting extended feedback from the vehicle platform.",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "accel_report",
				"data_type" : [{
					"name" : "enabled",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "override_active",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "command_output_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "input_output_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "output_reported_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "pacmod_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "vehicle_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "manual_input",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "command_value",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "output_value",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "brake_report",
				"data_type" : [{
					"name" : "enabled",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "override_active",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "command_output_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "input_output_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "output_reported_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "pacmod_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "vehicle_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "manual_input",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "command_value",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "output_value",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "steering_report",
				"data_type" : [{
					"name" : "enabled",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "override_active",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "command_output_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "input_output_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "output_reported_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "pacmod_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "vehicle_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "manual_input",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "command_value",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "output_value",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "hazardlights_report",
				"data_type" : [{
					"name" : "enabled",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "override_active",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "command_output_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "input_output_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "output_reported_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "pacmod_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "vehicle_fault",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "manual_input",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "command_value",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "output_value",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "headlights_report",
				"data_type" : [{
					"name" : "headlights_mode_valid",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "headlights_mode",
					"data_type" : [{
						"name" : "headlights_mode",
						"data_type" : "uint8",
						"units" : "",
						"description" : "0 = HEADLIGHTS_MODE_HEADLIGHTS_OFF<br>1 = HEADLIGHTS_MODE_PARKING_LIGHTS_ONLY<br>2 = HEADLIGHTS_MODE_HEADLIGHTS_ON_MANUAL_MODE<br>3 = HEADLIGHTS_MODE_HEADLIGHTS_ON_AUTO_MODE"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "fog_lights_on_valid",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "fog_lights_on",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "headlights_on_bright_valid",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "headlights_on_bright",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "headlights_on_valid",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "headlights_on",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "occupancy_report",
				"data_type" : [{
					"name" : "driver_seat_occupied_valid",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "driver_seat_occupied",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "driver_seatbelt_valid",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "driver_seatbelt",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "pass_seat_occupied_valid",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "pass_seat_occupied",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "pass_seatbelt_valid",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "pass_seatbelt",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "rear_seat_occupied_valid",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "rear_seat_occupied",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "rear_seatbelt_valid",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "rear_seatbelt",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/apollo_ros_bridge/cyberrt_ros/conti_radar/front",
			"nickname" : "Apollo / radar/front",
			"db_table_name" : "apollo_ros_bridge-cyberrt_ros-conti_radar-front",
			"ROS_topic_name" : "/apollo_ros_bridge/cyberrt_ros/conti_radar/front",
			"ROS_data_type" : "radar_msgs/ContiRadar (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "Collection topic for data from the forward-facing Continental ARS 408-21 radar unit.",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "contiobs",
				"data_type" : [{
					"name" : "header",
					"data_type" : [{
						"name" : "seq",
						"data_type" : "uint32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "stamp",
						"data_type" : [{
							"name" : "secs",
							"data_type" : "uint32",
							"units" : "s",
							"description" : "Seconds (stamp_secs) since epoch"
						},
						{
							"name" : "nsecs",
							"data_type" : "uint32",
							"units" : "ms",
							"description" : "Nanoseconds since stamp_secs"
						}],
						"units" : "",
						"description" : ""
					},
					{
						"name" : "frame_id",
						"data_type" : "string",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "clusterortrack",
					"data_type" : "bool",
					"units" : "",
					"description" : "0 = track<br>1 = cluster"
				},
				{
					"name" : "obstacle_id",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "longitude_dist",
					"data_type" : "float32",
					"units" : "m",
					"description" : "longitude distance to the radar; (+) = forward"
				},
				{
					"name" : "lateral_dist",
					"data_type" : "float32",
					"units" : "m",
					"description" : "lateral distance to the radar; (+) = left"
				},
				{
					"name" : "longitude_vel",
					"data_type" : "float32",
					"units" : "m/s",
					"description" : "longitude velocity to the radar; (+) = forward"
				},
				{
					"name" : "lateral_vel",
					"data_type" : "float32",
					"units" : "m/s",
					"description" : "lateral velocity to the radar; (+) = left"
				},
				{
					"name" : "rcs",
					"data_type" : "float32",
					"units" : "dBsm",
					"description" : "obstacle Radar Cross-Section"
				},
				{
					"name" : "dynprop",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = MOVING<br>1 = STATIONARY<br>2 = ONCOMING<br>3 = STATIONARY CANDIDATE<br>4 = UNKNOWN<br>5 = CROSSING STATIONARY<br>6 = CROSSING MOVING<br>7 = STOPPED"
				},
				{
					"name" : "longitude_dist_rms",
					"data_type" : "float32",
					"units" : "m",
					"description" : "longitude distance standard deviation to the radar; (+) = forward"
				},
				{
					"name" : "lateral_dist_rms",
					"data_type" : "float32",
					"units" : "m",
					"description" : "lateral distance standard deviation to the radar; (+) = left"
				},
				{
					"name" : "longitude_vel_rms",
					"data_type" : "float32",
					"units" : "m/s",
					"description" : "longitude velocity standard deviation to the radar; (+) = forward"
				},
				{
					"name" : "lateral_vel_rms",
					"data_type" : "float32",
					"units" : "m/s",
					"description" : "lateral velocity standard deviation to the radar; (+) = left"
				},
				{
					"name" : "probexist",
					"data_type" : "float32",
					"units" : "",
					"description" : "obstacle probability of existence"
				},
				{
					"name" : "meas_state",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = DELETED<br>1 = NEW<br>2 = MEASURED<br>3 = PREDICTED<br>4 = DELETED FOR<br>5 = NEW FROM MER"
				},
				{
					"name" : "longitude_accel",
					"data_type" : "float32",
					"units" : "m/s^2",
					"description" : ""
				},
				{
					"name" : "lateral_accel",
					"data_type" : "float32",
					"units" : "m/s^2",
					"description" : ""
				},
				{
					"name" : "oritation_angle",
					"data_type" : "float32",
					"units" : "deg",
					"description" : ""
				},
				{
					"name" : "longitude_accel_rms",
					"data_type" : "float32",
					"units" : "m/s^2",
					"description" : ""
				},
				{
					"name" : "lateral_accel_rms",
					"data_type" : "float32",
					"units" : "m/s^2",
					"description" : ""
				},
				{
					"name" : "oritation_angle_rms",
					"data_type" : "float32",
					"units" : "deg",
					"description" : ""
				},
				{
					"name" : "length",
					"data_type" : "float32",
					"units" : "m",
					"description" : ""
				},
				{
					"name" : "width",
					"data_type" : "float32",
					"units" : "m",
					"description" : ""
				},
				{
					"name" : "obstacle_class",
					"data_type" : [{
						"name" : "obstacle_class",
						"data_type" : "uint8",
						"units" : "",
						"description" : "0 = POINT<br>1 = CAR<br>2 = TRUCK<br>3 = PEDESTRIAN<br>4 = MOTORCYCLE<br>5 = BICYCLE<br>6 = WIDE<br>7 = UNKNOWN"
					}],
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "radar_state",
				"data_type" : [{
					"name" : "max_distance",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "radar_power",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "output_type",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "rcs_threshold",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "send_quality",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "send_ext_info",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "cluster_list_status",
				"data_type" : [{
					"name" : "near",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "far",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "meas_counter",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "interface_version",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "object_list_status",
				"data_type" : [{
					"name" : "nof_objects",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "meas_counter",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "interface_version",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/apollo_ros_bridge/cyberrt_ros/conti_radar/rear",
			"nickname" : "Apollo / radar/rear",
			"db_table_name" : "apollo_ros_bridge-cyberrt_ros-conti_radar-rear",
			"ROS_topic_name" : "/apollo_ros_bridge/cyberrt_ros/conti_radar/rear",
			"ROS_data_type" : "radar_msgs/ContiRadar (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "Collection topic for data from the rear-facing Continental ARS 408-21 radar unit.",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "contiobs",
				"data_type" : [{
					"name" : "header",
					"data_type" : [{
						"name" : "seq",
						"data_type" : "uint32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "stamp",
						"data_type" : [{
							"name" : "secs",
							"data_type" : "uint32",
							"units" : "s",
							"description" : "Seconds (stamp_secs) since epoch"
						},
						{
							"name" : "nsecs",
							"data_type" : "uint32",
							"units" : "ms",
							"description" : "Nanoseconds since stamp_secs"
						}],
						"units" : "",
						"description" : ""
					},
					{
						"name" : "frame_id",
						"data_type" : "string",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "clusterortrack",
					"data_type" : "bool",
					"units" : "",
					"description" : "0 = track<br>1 = cluster"
				},
				{
					"name" : "obstacle_id",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "longitude_dist",
					"data_type" : "float32",
					"units" : "m",
					"description" : "longitude distance to the radar; (+) = forward"
				},
				{
					"name" : "lateral_dist",
					"data_type" : "float32",
					"units" : "m",
					"description" : "lateral distance to the radar; (+) = left"
				},
				{
					"name" : "longitude_vel",
					"data_type" : "float32",
					"units" : "m/s",
					"description" : "longitude velocity to the radar; (+) = forward"
				},
				{
					"name" : "lateral_vel",
					"data_type" : "float32",
					"units" : "m/s",
					"description" : "lateral velocity to the radar; (+) = left"
				},
				{
					"name" : "rcs",
					"data_type" : "float32",
					"units" : "dBsm",
					"description" : "obstacle Radar Cross-Section"
				},
				{
					"name" : "dynprop",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = MOVING<br>1 = STATIONARY<br>2 = ONCOMING<br>3 = STATIONARY CANDIDATE<br>4 = UNKNOWN<br>5 = CROSSING STATIONARY<br>6 = CROSSING MOVING<br>7 = STOPPED"
				},
				{
					"name" : "longitude_dist_rms",
					"data_type" : "float32",
					"units" : "m",
					"description" : "longitude distance standard deviation to the radar; (+) = forward"
				},
				{
					"name" : "lateral_dist_rms",
					"data_type" : "float32",
					"units" : "m",
					"description" : "lateral distance standard deviation to the radar; (+) = left"
				},
				{
					"name" : "longitude_vel_rms",
					"data_type" : "float32",
					"units" : "m/s",
					"description" : "longitude velocity standard deviation to the radar; (+) = forward"
				},
				{
					"name" : "lateral_vel_rms",
					"data_type" : "float32",
					"units" : "m/s",
					"description" : "lateral velocity standard deviation to the radar; (+) = left"
				},
				{
					"name" : "probexist",
					"data_type" : "float32",
					"units" : "",
					"description" : "obstacle probability of existence"
				},
				{
					"name" : "meas_state",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = DELETED<br>1 = NEW<br>2 = MEASURED<br>3 = PREDICTED<br>4 = DELETED FOR<br>5 = NEW FROM MER"
				},
				{
					"name" : "longitude_accel",
					"data_type" : "float32",
					"units" : "m/s^2",
					"description" : ""
				},
				{
					"name" : "lateral_accel",
					"data_type" : "float32",
					"units" : "m/s^2",
					"description" : ""
				},
				{
					"name" : "oritation_angle",
					"data_type" : "float32",
					"units" : "deg",
					"description" : ""
				},
				{
					"name" : "longitude_accel_rms",
					"data_type" : "float32",
					"units" : "m/s^2",
					"description" : ""
				},
				{
					"name" : "lateral_accel_rms",
					"data_type" : "float32",
					"units" : "m/s^2",
					"description" : ""
				},
				{
					"name" : "oritation_angle_rms",
					"data_type" : "float32",
					"units" : "deg",
					"description" : ""
				},
				{
					"name" : "length",
					"data_type" : "float32",
					"units" : "m",
					"description" : ""
				},
				{
					"name" : "width",
					"data_type" : "float32",
					"units" : "m",
					"description" : ""
				},
				{
					"name" : "obstacle_class",
					"data_type" : [{
						"name" : "obstacle_class",
						"data_type" : "uint8",
						"units" : "",
						"description" : "0 = POINT<br>1 = CAR<br>2 = TRUCK<br>3 = PEDESTRIAN<br>4 = MOTORCYCLE<br>5 = BICYCLE<br>6 = WIDE<br>7 = UNKNOWN"
					}],
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "radar_state",
				"data_type" : [{
					"name" : "max_distance",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "radar_power",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "output_type",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "rcs_threshold",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "send_quality",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "send_ext_info",
					"data_type" : "bool",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "cluster_list_status",
				"data_type" : [{
					"name" : "near",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "far",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "meas_counter",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "interface_version",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "object_list_status",
				"data_type" : [{
					"name" : "nof_objects",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "meas_counter",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "interface_version",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/apollo_ros_bridge/cyberrt_ros/control_cmd",
			"nickname" : "Apollo / control_cmd",
			"db_table_name" : "apollo_ros_bridge-cyberrt_ros-control_cmd",
			"ROS_topic_name" : "/apollo_ros_bridge/cyberrt_ros/control_cmd",
			"ROS_data_type" : "dbw_msgs/Control (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "drive_mode",
				"data_type" : [{
					"name" : "drive_mode",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = COMPLETE_MANUAL<br>1 = COMPLETE_AUTO_DRIVE<br>2 = AUTO_STEER_ONLY<br>3 = AUTO_SPEED_ONLY<br>4 = EMERGENCY_MODE"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "gear",
				"data_type" : [{
					"name" : "gear",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = GEAR_NEUTRAL<br>1 = GEAR_DRIVE<br>2 = GEAR_REVERSE<br>3 = GEAR_PARKING<br>4 = GEAR_LOW<br>5 = GEAR_INVALID<br>6 = GEAR_NONE"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "throttle",
				"data_type" : "float64",
				"units" : "(scale)",
				"description" : "0.0 ~ 1.0 (pedal fully depressed)"
			},
			{
				"name" : "brake",
				"data_type" : "float64",
				"units" : "(scale)",
				"description" : "0.0 ~ 1.0 (pedal fully depressed)"
			},
			{
				"name" : "steering_rate",
				"data_type" : "float64",
				"units" : "rad / s",
				"description" : "0.0 ~ 100.0 [%] / s"
			},
			{
				"name" : "steering",
				"data_type" : "float64",
				"units" : "%",
				"description" : "(ccw:+) or (cw:-) from centered position (100% being approximate steering wheel limit)"
			},
			{
				"name" : "steering_rad",
				"data_type" : "float32",
				"units" : "rad",
				"description" : "(ccw:+) or (cw:-) from centered position"
			},
			{
				"name" : "speed",
				"data_type" : "float64",
				"units" : "m/s",
				"description" : ""
			},
			{
				"name" : "acceleration",
				"data_type" : "float64",
				"units" : "m/s^2",
				"description" : ""
			},
			{
				"name" : "latency_time",
				"data_type" : "float64",
				"units" : "ms",
				"description" : ""
			},
			{
				"name" : "turn_signal",
				"data_type" : [{
					"name" : "turn_signal",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = TURN_NONE<br>1 = TURN_LEFT<br>2 = TURN_RIGHT"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "speed_reference",
				"data_type" : "float64",
				"units" : "m/s",
				"description" : ""
			},
			{
				"name" : "speed_error",
				"data_type" : "float64",
				"units" : "m/s",
				"description" : ""
			},
			{
				"name" : "lateral_error",
				"data_type" : "float64",
				"units" : "m",
				"description" : ""
			},
			{
				"name" : "engage_advice",
				"data_type" : [{
					"name" : "engage_advice",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = UNKNOWN (not used)<br>1 = DISALLOW_ENGAGE<br>2 = READY_TO_ENGAGE<br>3 = KEEP_ENGAGED<br>4 = PREPARE_DISENGAGE"
				}],
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/apollo_ros_bridge/cyberrt_ros/corrected_imu",
			"nickname" : "Apollo / corrected_imu",
			"db_table_name" : "apollo_ros_bridge-cyberrt_ros-corrected_imu",
			"ROS_topic_name" : "/apollo_ros_bridge/cyberrt_ros/corrected_imu",
			"ROS_data_type" : "sensor_msgs/Imu (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "orientation",
				"data_type" : "float64[9]",
				"units" : "",
				"description" : "Rows major about x, y, z axes"
			},
			{
				"name" : "angular_velocity",
				"data_type" : "float64[9]",
				"units" : "",
				"description" : "Rows major about x, y, z axes"
			},
			{
				"name" : "linear_acceleration",
				"data_type" : "float64[9]",
				"units" : "",
				"description" : "Rows major about x, y, z axes"
			}]
		},
		{
			"name" : "/apollo_ros_bridge/cyberrt_ros/odom",
			"nickname" : "Apollo / odom",
			"db_table_name" : "apollo_ros_bridge-cyberrt_ros-odom",
			"ROS_topic_name" : "/apollo_ros_bridge/cyberrt_ros/odom",
			"ROS_data_type" : "nav_msgs/Odometry (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "child_frame_id",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "pose",
				"data_type" : [{
					"name" : "pose",
					"data_type" : [{
						"name" : "position",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float32",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float32",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float32",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					},
					{
						"name" : "orientation",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "w",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "covariance",
					"data_type" : "float64[3]",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "twist",
				"data_type" : [{
					"name" : "twist",
					"data_type" : [{
						"name" : "linear",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					},
					{
						"name" : "angular",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "covariance",
					"data_type" : "float64[3]",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/apollo_ros_bridge/cyberrt_ros/path",
			"nickname" : "Apollo / path",
			"db_table_name" : "apollo_ros_bridge-cyberrt_ros-path",
			"ROS_topic_name" : "/apollo_ros_bridge/cyberrt_ros/path",
			"ROS_data_type" : "nav_msgs/Path (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "poses",
				"data_type" : [{
					"name" : "header",
					"data_type" : [{
						"name" : "seq",
						"data_type" : "uint32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "stamp",
						"data_type" : [{
							"name" : "secs",
							"data_type" : "uint32",
							"units" : "s",
							"description" : "Seconds (stamp_secs) since epoch"
						},
						{
							"name" : "nsecs",
							"data_type" : "uint32",
							"units" : "ms",
							"description" : "Nanoseconds since stamp_secs"
						}],
						"units" : "",
						"description" : ""
					},
					{
						"name" : "frame_id",
						"data_type" : "string",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "pose",
					"data_type" : [{
						"name" : "position",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float32",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float32",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float32",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					},
					{
						"name" : "orientation",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "w",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/apollo_ros_bridge/cyberrt_ros/perception_obstacles",
			"nickname" : "Apollo / perception_obstacles",
			"db_table_name" : "apollo_ros_bridge-cyberrt_ros-perception_obstacles",
			"ROS_topic_name" : "/apollo_ros_bridge/cyberrt_ros/perception_obstacles",
			"ROS_data_type" : "perception_msgs/PerceptionObstacleArray (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "objects",
				"data_type" : [{
					"name" : "id",
					"data_type" : "",
					"units" : "",
					"description" : "Obstacle ID"
				},
				{
					"name" : "pose",
					"data_type" : [{
						"name" : "x",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "y",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "z",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : "Obstacle position in the world coordinate system"
				},
				{
					"name" : "theta",
					"data_type" : "float64",
					"units" : "",
					"description" : "Obstacle heading in the world coordinate system"
				},
				{
					"name" : "velocity",
					"data_type" : [{
						"name" : "x",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "y",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "z",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : "Obstacle velocity"
				},
				{
					"name" : "dimensions",
					"data_type" : [{
						"name" : "x",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "y",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "z",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : "Obstacle length, width, height"
				},
				{
					"name" : "polygon_points",
					"data_type" : [{
						"name" : "x",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "y",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "z",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : "Obstacle corner points"
				},
				{
					"name" : "tracking_time",
					"data_type" : "float64",
					"units" : "s",
					"description" : "Duration of an obstacle since detection"
				},
				{
					"name" : "type",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = UNKNOWN<br>1 = UNKNOWN_MOVABLE<br>2 = UNKNOWN_UNMOVABLE<br>3 = PEDESTRIAN<br>4 = BICYCLE<br>5 = VEHICLE"
				},
				{
					"name" : "timestamp",
					"data_type" : "float64",
					"units" : "s",
					"description" : "GPS time"
				},
				{
					"name" : "confidence",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "confidence_type",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = CONFIDENCE_UNKNOWN<br>1 = CONFIDENCE_CNN<br>2 = CONFIDENCE_RADAR"
				},
				{
					"name" : "acceleration",
					"data_type" : [{
						"name" : "x",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "y",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "z",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : "Obstacle acceleration"
				},
				{
					"name" : "anchor_point",
					"data_type" : [{
						"name" : "x",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "y",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "z",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : "A stable obstacle point in the world coordinate system position defined above is the obstacle bounding box ground center"
				},
				{
					"name" : "xmin",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "ymin",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "xmax",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "ymax",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "sub_type",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = ST_UNKNOWN<br>1 = ST_UNKNOWN_MOVABLE<br>2 = ST_UNKNOWN_UNMOVABLE<br>3 = ST_CAR<br>4 = ST_VAN<br>5 = ST_TRUCK<br>6 = ST_BUS<br>7 = ST_CYCLIST<br>8 = ST_MOTORCYCLIST<br>9 = ST_TRICYCLIST<br>10 = ST_PEDESTRIAN<br>11 = ST_TRAFFICCONE"
				},
				{
					"name" : "measurements",
					"data_type" : "PerceptionSensor[]",
					"units" : "",
					"description" : "(Sensor measurements)"
				},
				{
					"name" : "height_above_ground",
					"data_type" : "float64",
					"units" : "",
					"description" : "Orthogonal distance between obstacle lowest point and ground plane"
				},
				{
					"name" : "position_covariance",
					"data_type" : "float64[]",
					"units" : "",
					"description" : "Position covariance which is a row-majored 3x3 matrix"
				},
				{
					"name" : "velocity_covariance",
					"data_type" : "float64[]",
					"units" : "",
					"description" : "Velocity covariance which is a row-majored 3x3 matrix"
				},
				{
					"name" : "acceleration_covariance",
					"data_type" : "float64[]",
					"units" : "",
					"description" : "Acceleration covariance which is a row-majored 3x3 matrix"
				}],
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/apollo_ros_bridge/cyberrt_ros/tf",
			"nickname" : "Apollo / tf",
			"db_table_name" : "apollo_ros_bridge-cyberrt_ros-tf",
			"ROS_topic_name" : "/apollo_ros_bridge/cyberrt_ros/tf",
			"ROS_data_type" : "tf/tfMessage (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "",
			"collected_as" : "",
			"data_table" : [{
				"name" : "transforms",
				"data_type" : [{
					"name" : "header",
					"data_type" : [{
						"name" : "seq",
						"data_type" : "uint32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "stamp",
						"data_type" : [{
							"name" : "secs",
							"data_type" : "uint32",
							"units" : "s",
							"description" : "Seconds (stamp_secs) since epoch"
						},
						{
							"name" : "nsecs",
							"data_type" : "uint32",
							"units" : "ms",
							"description" : "Nanoseconds since stamp_secs"
						}],
						"units" : "",
						"description" : ""
					},
					{
						"name" : "frame_id",
						"data_type" : "string",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "child_frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "transform",
					"data_type" : [{
						"name" : "translation",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					},
					{
						"name" : "rotation",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "w",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/apollo_ros_bridge/cyberrt_ros/traffic_light",
			"nickname" : "Apollo / traffic_light",
			"ROS_topic_name" : "/apollo_ros_bridge/cyberrt_ros/traffic_light",
			"ROS_data_type" : "perception_msgs/TrafficLightDetection (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "Data as perceived by the traffic light detection system.",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "traffic_lights",
				"data_type" : [{
					"name" : "color",
					"data_type" : "uint8",
					"units" : "",
					"description" : "0 = UNKNOWN<br>1 = RED<br>2 = YELLOW<br>3 = GREEN<br>4 = BLACK"
				},
				{
					"name" : "id",
					"data_type" : "string",
					"units" : "",
					"description" : "Traffic Light ID (from HD map)"
				},
				{
					"name" : "confidence",
					"data_type" : "float64",
					"units" : "",
					"description" : "How confident about the detection results, between 0 and 1."
				},
				{
					"name" : "tracking_time",
					"data_type" : "float64",
					"units" : "",
					"description" : "Tracking age since last detected"
				},
				{
					"name" : "blink",
					"data_type" : "bool",
					"units" : "",
					"description" : "Is traffic light blinking"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "contain_lights",
				"data_type" : "bool",
				"units" : "",
				"description" : "Flag for whether a traffic signal is detected within the camera constraints (corresponding to HD map placement)."
			},
			{
				"name" : "camera_id",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 (Not used)"
			}]
		},
		{
			"name" : "/apollo_ros_bridge/cyberrt_ros/velodyne/fusion/points",
			"nickname" : "Apollo / point_cloud_fusion",
			"db_table_name" : "apollo_ros_bridge-cyberrt_ros-velodyne-fusion-points",
			"ROS_topic_name" : "/apollo_ros_bridge/cyberrt_ros/velodyne/fusion/points",
			"ROS_data_type" : "sensor_msgs/PointCloud2 (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "Collection for fused point cloud data from Velodyne LIDAR units on the vehicle. Includes the forward-facing, roof-mounted Velodyne VLP-32C unit and the left-facing, driver-side Velodyne VLP-16 unit.<br><br>This message holds a collection of N-dimensional points, which may contain additional information such as normals, intensity, etc. The point data is stored as a binary blob, its layout described by the contents of the \"fields\" array.<br><br>The point cloud data may be organized 2d (image-like) or 1d (unordered). Point clouds organized as 2d images may be produced by camera depth sensors such as stereo or time-of-flight.<br><br>Time of sensor data acquisition, and the coordinate frame ID (for 3d points).",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "height",
				"data_type" : "uint32",
				"units" : "",
				"description" : "2D structure of the point cloud. If the cloud is unordered, height is 1 and the width is the length of the point cloud."
			},
			{
				"name" : "width",
				"data_type" : "uint32",
				"units" : "",
				"description" : "2D structure of the point cloud. If the cloud is unordered, height is 1 and the width is the length of the point cloud."
			},
			{
				"name" : "fields",
				"data_type" : [{
					"name" : "name",
					"data_type" : "string",
					"units" : "",
					"description" : "Name of the field"
				},
				{
					"name" : "offset",
					"data_type" : "uint32",
					"units" : "",
					"description" : "Offset from start of point struct"
				},
				{
					"name" : "datatype",
					"data_type" : "uint8",
					"units" : "",
					"description" : "Datatype enumeration<br>1 = INT8<br>2 = UINT8<br>3 = INT16<br>4 = UINT16<br>5 = INT32<br>6 = UINT32<br>7 = FLOAT32<br>8 = FLOAT64"
				},
				{
					"name" : "count",
					"data_type" : "uint32",
					"units" : "",
					"description" : "How many elements in the field"
				}],
				"units" : "",
				"description" : "Describes the channels and their layout in the binary data blob"
			},
			{
				"name" : "is_bigendian",
				"data_type" : "bool",
				"units" : "",
				"description" : "Is this data bigendian?"
			},
			{
				"name" : "point_step",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Length of a point in bytes"
			},
			{
				"name" : "row_step",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Length of a row in bytes"
			},
			{
				"name" : "data",
				"data_type" : "uint8[]",
				"units" : "",
				"description" : "Actual point data, size is (row_step * height)"
			},
			{
				"name" : "is_dense",
				"data_type" : "bool",
				"units" : "",
				"description" : "True if there are no invalid points"
			}]
		},
		{
			"name" : "/chassis_ext",
			"nickname" : "Chassis (extended)",
			"db_table_name" : "chassis_ext",
			"ROS_topic_name" : "/chassis_ext",
			"ROS_data_type" : "std_msgs/String",
			"collection_rate" : "~1Hz",
			"description" : "Collection topic for additional CAN bus information (odometer).",
			"collected_as" : "JSON string",
			"data_table" : [{
				"name" : "timestamp",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Vehicle time (UNIX epoch)"
			},
			{
				"name" : "odo_reading",
				"data_type" : "float32",
				"units" : "km",
				"description" : "Chassis odometer reading (OEM)"
			},
			{
				"name" : "odo_reading_e",
				"data_type" : "float32",
				"units" : "miles",
				"description" : "Chassis odometer reading (English conversion)"
			}]
		},
		{
			"name" : "/md30",
			"nickname" : "Vaisala MD30",
			"db_table_name" : "md30",
			"ROS_topic_name" : "/md30",
			"ROS_data_type" : "std_msgs/String",
			"collection_rate" : "1Hz",
			"description" : "Collection topic for information from the Vaisala MD30 Mobile Detector [https://www.vaisala.com/en/support/md30](https://www.vaisala.com/en/support/md30)<br><br>[MD30 interface document (English)](https://www.vaisala.com/sites/default/files/documents/MD30-Interface-Description-in-English-M212201EN.pdf)",
			"collected_as" : "JSON string",
			"data_table" : [{
				"name" : "timestamp",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Vehicle time (UNIX epoch)"
			},
			{
				"name" : "unit_id",
				"data_type" : "uint8",
				"units" : "",
				"description" : "1"
			},
			{
				"name" : "client_id",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0"
			},
			{
				"name" : "id",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "icd_version",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "error",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "water_layer_thickness",
				"data_type" : "float32",
				"units" : "mm",
				"description" : "Range: 0 ... 60 (0 ... 2.36 in)<br>(Missing data: NaN)"
			},
			{
				"name" : "ice_layer_thickness",
				"data_type" : "float32",
				"units" : "mm",
				"description" : "Range: 0 ... 60 (0 ... 2.36 in)<br>(Missing data: NaN)"
			},
			{
				"name" : "snow_layer_thickness",
				"data_type" : "float32",
				"units" : "mm",
				"description" : "Range: 0 ... 60 (0 ... 2.36 in)<br>(Missing data: NaN)"
			},
			{
				"name" : "grip",
				"data_type" : "float32",
				"units" : "",
				"description" : "Grip value<br>Range: 0.09 ... 0.82<br>(Missing data: NaN)"
			},
			{
				"name" : "road_state",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = Error<br>1 = Dry<br>2 = Moist<br>3 = Wet<br>4 = -<br>5 = -<br>6 = Snowy<br>7 = Icy<br>8 = -<br>9 = Slushy<br>10-12 = -"
			},
			{
				"name" : "en15518_state",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = Error<br>1 = Dry<br>2 = Moist<br>3 = Wet<br>4-9 = -<br>10 = Streaming water<br>11 = Slippery"
			},
			{
				"name" : "air_temp",
				"data_type" : "float32",
				"units" : "deg C",
				"description" : "Measured air temperature<br>Range: -40 ... 60 (-40 ... +140 °F)<br>(Missing data: NaN)"
			},
			{
				"name" : "relative_air_humidity",
				"data_type" : "float32",
				"units" : "%",
				"description" : "Measured relative humidity<br>Range: 0 ... 100<br>(Missing data: NaN)"
			},
			{
				"name" : "dew_point_temp",
				"data_type" : "float32",
				"units" : "deg C",
				"description" : "Range: -40 ... +60 (-40 ... +140 °F)<br>(Missing data: NaN)<br><br>As dew does not form in freezing conditions, dew point value is not relevant when it is below 0 °C"
			},
			{
				"name" : "frost_point_temp",
				"data_type" : "float32",
				"units" : "deg C",
				"description" : "Dew / frost point temperature (dew point reported above freezing conditions, frost point reported in freezing conditions) <br>Range: -40 ... +60<br>(Missing data: NaN)<br><br>In freezing conditions, instead of dew point, the relevant value for understanding the risk of frost (ice) formation is frost point"
			},
			{
				"name" : "surface_temp",
				"data_type" : "float32",
				"units" : "deg C",
				"description" : "Measured road surface temperature <br>Range: -40 ... +60<br>(Missing data: NaN)"
			},
			{
				"name" : "analyze_count",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Incrementing number of road measurements since device boot"
			},
			{
				"name" : "data_status_warning",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "data_status_error",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "data_status_info",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "unit_status_info",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "unit_error_info",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/mobileye/as_tx/lane_markers",
			"nickname" : "Mobileye / lane_markers",
			"ROS_topic_name" : "/mobileye/as_tx/lane_markers",
			"ROS_data_type" : "visualization_msgs/Marker (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "ns",
				"data_type" : "string",
				"units" : "",
				"description" : "Namespace to place this object in... used in conjunction with id to create a unique name for the object"
			},
			{
				"name" : "id",
				"data_type" : "int32",
				"units" : "",
				"description" : "Object ID useful in conjunction with the namespace for manipulating and deleting the object later"
			},
			{
				"name" : "type",
				"data_type" : "int32",
				"units" : "",
				"description" : "Type of object"
			},
			{
				"name" : "action",
				"data_type" : "int32",
				"units" : "",
				"description" : "0 = Add/modify an object<br>1 = (Deprecated)<br>2 = Delete an object<br>3 = Delete all objects"
			},
			{
				"name" : "pose",
				"data_type" : [{
					"name" : "position",
					"data_type" : [{
						"name" : "x",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "y",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "z",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "orientation",
					"data_type" : [{
						"name" : "x",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "y",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "z",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "w",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : "Pose of the object"
			},
			{
				"name" : "scale",
				"data_type" : [{
					"name" : "x",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "y",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "z",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : "Scale of the object. 1,1,1 means default (usually 1 meter square)"
			},
			{
				"name" : "color",
				"data_type" : [{
					"name" : "r",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "g",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "b",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "a",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : "Color [0.0 - 1.0)"
			},
			{
				"name" : "lifetime",
				"data_type" : [{
					"name" : "secs",
					"data_type" : "uint8",
					"units" : "s",
					"description" : ""
				},
				{
					"name" : "nsecs",
					"data_type" : "uint8",
					"units" : "ns",
					"description" : ""
				}],
				"units" : "",
				"description" : "How long the object should last before being automatically deleted. 0 means forever."
			},
			{
				"name" : "frame_locked",
				"data_type" : "bool",
				"units" : "",
				"description" : "If this marker should be frame-locked, i.e. retransformed into its frame every timestep"
			},
			{
				"name" : "points",
				"data_type" : [{
					"name" : "x",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "y",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "z",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : "(Only used if the type specified has some use for them (eg. POINTS, LINE_STRIP, etc)"
			},
			{
				"name" : "colors",
				"data_type" : [{
					"name" : "r",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "g",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "b",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "a",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : "(Only used if the type specified has some use for them (eg. POINTS, LINE_STRIP, ...)<br><br>Number of colors must either be 0 or equal to the number of points. Alpha is not yet used"
			},
			{
				"name" : "text",
				"data_type" : "string",
				"units" : "",
				"description" : "(Only used for text markers)"
			},
			{
				"name" : "mesh_resource",
				"data_type" : "string",
				"units" : "",
				"description" : "(Only used for MESH_RESOURCE markers)"
			},
			{
				"name" : "mesh_resource_embedded_materials",
				"data_type" : "bool",
				"units" : "",
				"description" : "(Only used for MESH_RESOURCE markers)"
			}]
		},
		{
			"name" : "/mobileye/as_tx/lane_models",
			"nickname" : "Mobileye / lane_models",
			"ROS_topic_name" : "/mobileye/as_tx/lane_models",
			"ROS_data_type" : "derived_object_msgs/LaneModels",
			"collection_rate" : "",
			"description" : "",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "left_lane",
				"data_type" : [{
					"name" : "quality",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "marker_kind",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "curve_model_kind",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "marker_offset",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "heading_angle",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "curvature",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "curvature_derivative",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "marker_width",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "view_range",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "right_lane",
				"data_type" : [{
					"name" : "quality",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "marker_kind",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "curve_model_kind",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "marker_offset",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "heading_angle",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "curvature",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "curvature_derivative",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "marker_width",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "view_range",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "additional_lanes",
				"data_type" : [{
					"name" : "quality",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "marker_kind",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "curve_model_kind",
					"data_type" : "uint8",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "marker_offset",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "heading_angle",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "curvature",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "curvature_derivative",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "marker_width",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "view_range",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/mobileye/as_tx/object_markers",
			"nickname" : "Mobileye / object_markers",
			"ROS_topic_name" : "/mobileye/as_tx/object_markers",
			"ROS_data_type" : "visualization_msgs/Marker (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "ns",
				"data_type" : "string",
				"units" : "",
				"description" : "Namespace to place this object in... used in conjunction with id to create a unique name for the object"
			},
			{
				"name" : "id",
				"data_type" : "int32",
				"units" : "",
				"description" : "Object ID useful in conjunction with the namespace for manipulating and deleting the object later"
			},
			{
				"name" : "type",
				"data_type" : "int32",
				"units" : "",
				"description" : "Type of object"
			},
			{
				"name" : "action",
				"data_type" : "int32",
				"units" : "",
				"description" : "0 = Add/modify an object<br>1 = (Deprecated)<br>2 = Delete an object<br>3 = Delete all objects"
			},
			{
				"name" : "pose",
				"data_type" : [{
					"name" : "position",
					"data_type" : [{
						"name" : "x",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "y",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "z",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "orientation",
					"data_type" : [{
						"name" : "x",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "y",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "z",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "w",
						"data_type" : "float64",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : "Pose of the object"
			},
			{
				"name" : "scale",
				"data_type" : [{
					"name" : "x",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "y",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "z",
					"data_type" : "float64",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : "Scale of the object. 1,1,1 means default (usually 1 meter square)"
			},
			{
				"name" : "color",
				"data_type" : [{
					"name" : "r",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "g",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "b",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "a",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : "Color [0.0 - 1.0)"
			},
			{
				"name" : "lifetime",
				"data_type" : [{
					"name" : "secs",
					"data_type" : "uint8",
					"units" : "s",
					"description" : ""
				},
				{
					"name" : "nsecs",
					"data_type" : "uint8",
					"units" : "ns",
					"description" : ""
				}],
				"units" : "",
				"description" : "How long the object should last before being automatically deleted. 0 means forever."
			},
			{
				"name" : "frame_locked",
				"data_type" : "bool",
				"units" : "",
				"description" : "If this marker should be frame-locked, i.e. retransformed into its frame every timestep"
			},
			{
				"name" : "points",
				"data_type" : [{
					"name" : "x",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "y",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "z",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : "(Only used if the type specified has some use for them (eg. POINTS, LINE_STRIP, etc)"
			},
			{
				"name" : "colors",
				"data_type" : [{
					"name" : "r",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "g",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "b",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "a",
					"data_type" : "float32",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : "(Only used if the type specified has some use for them (eg. POINTS, LINE_STRIP, ...)<br><br>Number of colors must either be 0 or equal to the number of points. Alpha is not yet used"
			},
			{
				"name" : "text",
				"data_type" : "string",
				"units" : "",
				"description" : "(Only used for text markers)"
			},
			{
				"name" : "mesh_resource",
				"data_type" : "string",
				"units" : "",
				"description" : "(Only used for MESH_RESOURCE markers)"
			},
			{
				"name" : "mesh_resource_embedded_materials",
				"data_type" : "bool",
				"units" : "",
				"description" : "(Only used for MESH_RESOURCE markers)"
			}]
		},
		{
			"name" : "/mobileye/as_tx/objects",
			"nickname" : "Mobileye / objects",
			"ROS_topic_name" : "/mobileye/as_tx/objects",
			"ROS_data_type" : "derived_object_msgs/ObjectWithCovariance",
			"collection_rate" : "",
			"description" : "",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "id",
				"data_type" : "uint32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "detection_level",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = OBJECT_DETECTED<br>1 = OBJECT_TRACKED"
			},
			{
				"name" : "object_classified",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "pose",
				"data_type" : [{
					"name" : "pose",
					"data_type" : [{
						"name" : "position",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float32",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float32",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float32",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					},
					{
						"name" : "orientation",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "w",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "covariance",
					"data_type" : "float64[36]",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "twist",
				"data_type" : [{
					"name" : "twist",
					"data_type" : [{
						"name" : "linear",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					},
					{
						"name" : "angular",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "covariance",
					"data_type" : "float64[36]",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "accel",
				"data_type" : [{
					"name" : "accel",
					"data_type" : [{
						"name" : "linear",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					},
					{
						"name" : "angular",
						"data_type" : [{
							"name" : "x",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "y",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						},
						{
							"name" : "z",
							"data_type" : "float64",
							"units" : "",
							"description" : ""
						}],
						"units" : "",
						"description" : ""
					}],
					"units": "",
					"description" : ""
				},
				{
					"name" : "covariance",
					"data_type" : "float64[36]",
					"units": "",
					"description" : "Row-major representation of the 6x6 covariance matrix. The orientation parameters use a fixed-axis representation.<br><br>In order, the parameters are: (x, y, z, rotation about X axis, rotation about Y axis, rotation about Z axis)"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "polygon",
				"data_type" : [{
					"name" : "points",
					"data_type" : [{
						"name" : "x",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "y",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "z",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					}],
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "shape",
				"data_type" : [{
					"name" : "type",
					"data_type" : "uint8",
					"units" : "",
					"description" : "1 = BOX<br>2 = SPHERE<br>3 = CYLINDER<br>4 = CONE"
				},
				{
					"name" : "dimensions",
					"data_type" : "float64[]",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "classification",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = CLASSIFICATION_UNKNOWN<br>1 = CLASSIFICATION_UNKNOWN_SMALL<br>2 = CLASSIFICATION_UNKNOWN_MEDIUM<br>3 = CLASSIFICATION_UNKNOWN_BIG<br>4 = CLASSIFICATION_PEDESTRIAN<br>5 = CLASSIFICATION_BIKE<br>6 = CLASSIFICATION_CAR<br>7 = CLASSIFICATION_TRUCK<br>8 = CLASSIFICATION_MOTORCYCLE<br>9 = CLASSIFICATION_OTHER_VEHICLE<br>10 = CLASSIFICATION_BARRIER<br>11 = CLASSIFICATION_SIGN"
			},
			{
				"name" : "classification_certainty",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "classification_age",
				"data_type" : "uint32",
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/mobileye/can_tx",
			"nickname" : "Mobileye / can_tx",
			"ROS_topic_name" : "/mobileye/can_tx",
			"ROS_data_type" : "can_msgs/Frame",
			"collection_rate" : "",
			"description" : "",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "id",
				"data_type" : "uint32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "is_rtr",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "is_extended",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "is_error",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "dlc",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "data",
				"data_type" : "uint8[8]",
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/mobileye/parsed_tx/aftermarket_lane",
			"nickname" : "Mobileye / aftermarket_lane",
			"ROS_topic_name" : "/mobileye/parsed_tx/aftermarket_lane",
			"ROS_data_type" : "mobileye_560_660_msgs/AftermarketLane",
			"collection_rate" : "",
			"description" : "(Parsed)",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "lane_confidence_left",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = LANE_CONFIDENCE_NONE<br>1 = LANE_CONFIDENCE_LOW<br>2 = LANE_CONFIDENCE_MED<br>3 = LANE_CONFIDENCE_HIGH"
			},
			{
				"name" : "ldw_available_left",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "lane_type_left",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = LANE_TYPE_DASHED<br>1 = LANE_TYPE_SOLID<br>2 = LANE_TYPE_NONE<br>3 = LANE_TYPE_ROAD_EDGE<br>4 = LANE_TYPE_DOUBLE_LANE_MARK<br>5 = LANE_TYPE_BOTTS_DOTS<br>6 = LANE_TYPE_INVALID"
			},
			{
				"name" : "distance_to_left_lane",
				"data_type" : "float32",
				"units" : "m",
				"description" : ""
			},
			{
				"name" : "lane_confidence_right",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = LANE_CONFIDENCE_NONE<br>1 = LANE_CONFIDENCE_LOW<br>2 = LANE_CONFIDENCE_MED<br>3 = LANE_CONFIDENCE_HIGH"
			},
			{
				"name" : "ldw_available_right",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "lane_type_right",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = LANE_TYPE_DASHED<br>1 = LANE_TYPE_SOLID<br>2 = LANE_TYPE_NONE<br>3 = LANE_TYPE_ROAD_EDGE<br>4 = LANE_TYPE_DOUBLE_LANE_MARK<br>5 = LANE_TYPE_BOTTS_DOTS<br>6 = LANE_TYPE_INVALID"
			},
			{
				"name" : "distance_to_right_lane",
				"data_type" : "float32",
				"units" : "m",
				"description" : ""
			}]
		},
		{
			"name" : "/mobileye/parsed_tx/aws_display",
			"nickname" : "Mobileye / aws_display",
			"ROS_topic_name" : "/mobileye/parsed_tx/aws_display",
			"ROS_data_type" : "mobileye_560_660_msgs/AwsDisplay",
			"collection_rate" : "",
			"description" : "(Parsed)",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "suppress_sound",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "night_time",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "dusk_time",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "sound_type",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = SOUND_SILENT<br>1 = SOUND_LDWL<br>2 = SOUND_LDWR<br>3 = SOUND_FAR_HW<br>4 = SOUND_NEAR_HW<br>5 = SOUND_SOFT_FCW<br>6 = SOUND_HARD_FCW<br>7 = SOUND_RESERVED"
			},
			{
				"name" : "headway_valid",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "headway_measurement",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "lanes_on",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "left_ldw_on",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "right_ldw_on",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "fcw_on",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "left_crossing",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "right_crossing",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "maintenance",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "failsafe",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "ped_fcw",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "ped_in_dz",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "headway_warning_level",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = HEADWAY_LEVEL_OFF<br>1 = HEADWAY_LEVEL_GREEN<br>2 = HEADWAY_LEVEL_ORANGE<br>3 = HEADWAY_LEVEL_RED"
			}]
		},
		{
			"name" : "/mobileye/parsed_tx/fixed_foe",
			"nickname" : "Mobileye / fixed_foe",
			"ROS_topic_name" : "/mobileye/parsed_tx/fixed_foe",
			"ROS_data_type" : "mobileye_560_660_msgs/FixedFoe",
			"collection_rate" : "",
			"description" : "(Parsed)",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "fixed_yaw",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "fixed_horizon",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/mobileye/parsed_tx/lane",
			"nickname" : "Mobileye / lane",
			"ROS_topic_name" : "/mobileye/parsed_tx/lane",
			"ROS_data_type" : "mobileye_560_660_msgs/Lane",
			"collection_rate" : "",
			"description" : "(Parsed)",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "lane_curvature",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "lane_heading",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "construction_area",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "pitch_angle",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "yaw_angle",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "right_ldw_availability",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "left_ldw_availability",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/mobileye/parsed_tx/left_lka_lane",
			"nickname" : "Mobileye / left_lka_lane",
			"ROS_topic_name" : "/mobileye/parsed_tx/left_lka_lane",
			"ROS_data_type" : "mobileye_560_660_msgs/LkaLane",
			"collection_rate" : "",
			"description" : "(Parsed)",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "lane_type",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = LANE_TYPE_DASHED<br>1 = LANE_TYPE_SOLID<br>2 = LANE_TYPE_NONE<br>3 = LANE_TYPE_ROAD_EDGE<br>4 = LANE_TYPE_DOUBLE_LANE_MARK<br>5 = LANE_TYPE_BOTTS_DOTS<br>6 = LANE_TYPE_INVALID"
			},
			{
				"name" : "quality",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = LANE_CONFIDENCE_NONE<br>1 = LANE_CONFIDENCE_LOW<br>2 = LANE_CONFIDENCE_MED<br>3 = LANE_CONFIDENCE_HIGH"
			},
			{
				"name" : "model_degree",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "position_parameter_c0",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "curvature_parameter_c2",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "curvature_derivative_parameter_c3",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "marking_width",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "heading_angle_parameter_c1",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "view_range",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "view_range_availability",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/mobileye/parsed_tx/lka_num_of_next_lane_markers_reported",
			"nickname" : "Mobileye / lka_num_of_next_lane_markers",
			"ROS_topic_name" : "/mobileye/parsed_tx/lka_num_of_next_lane_markers_reported",
			"ROS_data_type" : "mobileye_560_660_msgs/LkaNumOfNextLaneMarkersReported",
			"collection_rate" : "",
			"description" : "(Parsed)",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "num_of_next_lane_markers_reported",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/mobileye/parsed_tx/lka_reference_points",
			"nickname" : "Mobileye / lka_reference_points",
			"ROS_topic_name" : "/mobileye/parsed_tx/lka_reference_points",
			"ROS_data_type" : "mobileye_560_660_msgs/LkaReferencePoints",
			"collection_rate" : "",
			"description" : "(Parsed)",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "ref_point_1_position",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "ref_point_1_distance",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "ref_point_1_validity",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "ref_point_2_position",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "ref_point_2_distance",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "ref_point_2_validity",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/mobileye/parsed_tx/next_lka_lanes",
			"nickname" : "Mobileye / next_lka_lanes",
			"ROS_topic_name" : "/mobileye/parsed_tx/next_lka_lanes",
			"ROS_data_type" : "mobileye_560_660_msgs/LkaLane",
			"collection_rate" : "",
			"description" : "(Parsed)",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "lane_type",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = LANE_TYPE_DASHED<br>1 = LANE_TYPE_SOLID<br>2 = LANE_TYPE_NONE<br>3 = LANE_TYPE_ROAD_EDGE<br>4 = LANE_TYPE_DOUBLE_LANE_MARK<br>5 = LANE_TYPE_BOTTS_DOTS<br>6 = LANE_TYPE_INVALID"
			},
			{
				"name" : "quality",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = LANE_CONFIDENCE_NONE<br>1 = LANE_CONFIDENCE_LOW<br>2 = LANE_CONFIDENCE_MED<br>3 = LANE_CONFIDENCE_HIGH"
			},
			{
				"name" : "model_degree",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "position_parameter_c0",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "curvature_parameter_c2",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "curvature_derivative_parameter_c3",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "marking_width",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "heading_angle_parameter_c1",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "view_range",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "view_range_availability",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/mobileye/parsed_tx/obstacle_data",
			"nickname" : "Mobileye / obstacle_data",
			"ROS_topic_name" : "/mobileye/parsed_tx/obstacle_data",
			"ROS_data_type" : "mobileye_560_660_msgs/ObstacleData",
			"collection_rate" : "",
			"description" : "(Parsed)",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "obstacle_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "obstacle_pos_x",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "obstacle_pos_y",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "blinker_info",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = BLINKER_INFO_UNAVAILABLE<br>1 = BLINKER_INFO_OFF<br>2 = BLINKER_INFO_LEFT<br>3 = BLINKER_INFO_RIGHT<br>4 = BLINKER_INFO_BOTH"
			},
			{
				"name" : "cut_in_and_out",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = CUT_IN_AND_OUT_UNDEFINED<br>1 = CUT_IN_AND_OUT_IN_HOST_LANE<br>2 = CUT_IN_AND_OUT_OUT_HOST_LANE<br>3 = CUT_IN_AND_OUT_CUT_IN<br>4 = CUT_IN_AND_OUT_CUT_OUT"
			},
			{
				"name" : "obstacle_rel_vel_x",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "obstacle_type",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = OBSTACLE_TYPE_VEHICLE<br>1 = OBSTACLE_TYPE_TRUCK<br>2 = OBSTACLE_TYPE_BIKE<br>3 = OBSTACLE_TYPE_PED<br>4 = OBSTACLE_TYPE_BICYCLE"
			},
			{
				"name" : "obstacle_status",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = OBSTACLE_STATUS_UNDEFINED<br>1 = OBSTACLE_STATUS_STANDING<br>2 = OBSTACLE_STATUS_STOPPED<br>3 = OBSTACLE_STATUS_MOVING<br>4 = OBSTACLE_STATUS_ONCOMING<br>5 = OBSTACLE_STATUS_PARKED"
			},
			{
				"name" : "obstacle_brake_lights",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "obstacle_valid",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = OBSTACLE_VALID_INVALID<br>1 = OBSTACLE_VALID_NEW<br>2 = OBSTACLE_VALID_OLDER"
			},
			{
				"name" : "obstacle_length",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "obstacle_width",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "obstacle_age",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "obstacle_lane",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = OBSTACLE_LANE_NOT_ASSIGNED<br>1 = OBSTACLE_LANE_EGO_LANE<br>2 = OBSTACLE_LANE_NEXT_LANE<br>3 = OBSTACLE_LANE_INVALID"
			},
			{
				"name" : "cipv_flag",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "radar_pos_x",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "radar_vel_x",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "radar_match_confidence",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = RADAR_MATCH_CONFIDENCE_NO_MATCH<br>1 = RADAR_MATCH_CONFIDENCE_MULTI_MATCH<br>2 = RADAR_MATCH_CONFIDENCE_BOUNDED_LOW<br>3 = RADAR_MATCH_CONFIDENCE_BOUNDED_MED<br>4 = RADAR_MATCH_CONFIDENCE_BOUNDED_HIGH<br>5 = RADAR_MATCH_CONFIDENCE_HIGH"
			},
			{
				"name" : "matched_radar_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "obstacle_angle_rate",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "obstacle_scale_change",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "object_accel_x",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "obstacle_replaced",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "obstacle_angle",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/mobileye/parsed_tx/obstacle_status",
			"nickname" : "Mobileye / obstacle_status",
			"ROS_topic_name" : "/mobileye/parsed_tx/obstacle_status",
			"ROS_data_type" : "mobileye_560_660_msgs/ObstacleStatus",
			"collection_rate" : "",
			"description" : "(parsed)",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "num_obstacles",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "timestamp",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "application_version",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "active_version_number_section",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "left_close_range_cut_in",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "right_close_range_cut_in",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "stop_go",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = STOP_GO_STOP<br>1 = STOP_GO_GO<br>2 = STOP_GO_UNDECIDED<br>3 = STOP_GO_DRIVER_DECISION_REQUIRED<br>15 = STOP_GO_NOT_CALCULATED<br>"
			},
			{
				"name" : "protocol_version",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "close_car",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "failsafe",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = FAILSAFE_NONE<br>1 = FAILSAFE_LOW_SUN<br>2 = FAILSAFE_BLUR_IMAGE"
			}]
		},
		{
			"name" : "/mobileye/parsed_tx/right_lka_lane",
			"nickname" : "Mobileye / right_lka_lane",
			"ROS_topic_name" : "/mobileye/parsed_tx/right_lka_lane",
			"ROS_data_type" : "mobileye_560_660_msgs/LkaLane",
			"collection_rate" : "",
			"description" : "(Parsed)",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "lane_type",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = LANE_TYPE_DASHED<br>1 = LANE_TYPE_SOLID<br>2 = LANE_TYPE_NONE<br>3 = LANE_TYPE_ROAD_EDGE<br>4 = LANE_TYPE_DOUBLE_LANE_MARK<br>5 = LANE_TYPE_BOTTS_DOTS<br>6 = LANE_TYPE_INVALID"
			},
			{
				"name" : "quality",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = LANE_CONFIDENCE_NONE<br>1 = LANE_CONFIDENCE_LOW<br>2 = LANE_CONFIDENCE_MED<br>3 = LANE_CONFIDENCE_HIGH"
			},
			{
				"name" : "model_degree",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "position_parameter_c0",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "curvature_parameter_c2",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "curvature_derivative_parameter_c3",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "marking_width",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "heading_angle_parameter_c1",
				"data_type" : "float64",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "view_range",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "view_range_availability",
				"data_type" : "bool",
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/mobileye/parsed_tx/tsr",
			"nickname" : "Mobileye / tsr",
			"ROS_topic_name" : "/mobileye/parsed_tx/tsr",
			"ROS_data_type" : "mobileye_560_660_msgs/Tsr",
			"collection_rate" : "",
			"description" : "(Parsed)",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "vision_only_sign_type",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = SIGN_TYPE_REGULAR_10<br>1 = SIGN_TYPE_REGULAR_20<br>2 = SIGN_TYPE_REGULAR_30<br>3 = SIGN_TYPE_REGULAR_40<br>4 = SIGN_TYPE_REGULAR_50<br>5 = SIGN_TYPE_REGULAR_60<br>6 = SIGN_TYPE_REGULAR_70<br>7 = SIGN_TYPE_REGULAR_80<br>8 = SIGN_TYPE_REGULAR_90<br>9 = SIGN_TYPE_REGULAR_100<br>10 = SIGN_TYPE_REGULAR_110<br>11 = SIGN_TYPE_REGULAR_120<br>12 = SIGN_TYPE_REGULAR_130<br>13 = SIGN_TYPE_REGULAR_140<br>20 = SIGN_TYPE_REGULAR_END_RESTRICTION_OF_NUMBER<br>28 = SIGN_TYPE_ELECTRONIC_10<br>29 = SIGN_TYPE_ELECTRONIC_20<br>30 = SIGN_TYPE_ELECTRONIC_30<br>31 = SIGN_TYPE_ELECTRONIC_40<br>32 = SIGN_TYPE_ELECTRONIC_50<br>33 = SIGN_TYPE_ELECTRONIC_60<br>34 = SIGN_TYPE_ELECTRONIC_70<br>35 = SIGN_TYPE_ELECTRONIC_80<br>36 = SIGN_TYPE_ELECTRONIC_90<br>37 = SIGN_TYPE_ELECTRONIC_100<br>38 = SIGN_TYPE_ELECTRONIC_110<br>39 = SIGN_TYPE_ELECTRONIC_120<br>40 = SIGN_TYPE_ELECTRONIC_130<br>41 = SIGN_TYPE_ELECTRONIC_140<br>50 = SIGN_TYPE_ELECTRONIC_END_RESTRICTION_OF_NUMBER<br>64 = SIGN_TYPE_REGULAR_GENERAL_END_ALL_RESTRICTION<br>65 = SIGN_TYPE_ELECTRONIC_GENERAL_END_ALL_RESTRICTION<br>100 = SIGN_TYPE_REGULAR_5<br>101 = SIGN_TYPE_REGULAR_15<br>102 = SIGN_TYPE_REGULAR_25<br>103 = SIGN_TYPE_REGULAR_35<br>104 = SIGN_TYPE_REGULAR_45<br>105 = SIGN_TYPE_REGULAR_55<br>106 = SIGN_TYPE_REGULAR_65<br>107 = SIGN_TYPE_REGULAR_75<br>108 = SIGN_TYPE_REGULAR_85<br>109 = SIGN_TYPE_REGULAR_95<br>110 = SIGN_TYPE_REGULAR_105<br>111 = SIGN_TYPE_REGULAR_115<br>112 = SIGN_TYPE_REGULAR_125<br>113 = SIGN_TYPE_REGULAR_135<br>114 = SIGN_TYPE_REGULAR_145<br>115 = SIGN_TYPE_ELECTRONIC_5<br>116 = SIGN_TYPE_ELECTRONIC_15<br>117 = SIGN_TYPE_ELECTRONIC_25<br>118 = SIGN_TYPE_ELECTRONIC_35<br>119 = SIGN_TYPE_ELECTRONIC_45<br>120 = SIGN_TYPE_ELECTRONIC_55<br>121 = SIGN_TYPE_ELECTRONIC_65<br>122 = SIGN_TYPE_ELECTRONIC_75<br>123 = SIGN_TYPE_ELECTRONIC_85<br>124 = SIGN_TYPE_ELECTRONIC_95<br>125 = SIGN_TYPE_ELECTRONIC_105<br>126 = SIGN_TYPE_ELECTRONIC_115<br>127 = SIGN_TYPE_ELECTRONIC_125<br>128 = SIGN_TYPE_ELECTRONIC_135<br>129 = SIGN_TYPE_ELECTRONIC_145<br>171 = SIGN_TYPE_REGULAR_MOTORWAY_BEGIN<br>172 = SIGN_TYPE_REGULAR_END_OF_MOTORWAY<br>173 = SIGN_TYPE_REGULAR_EXPRESSWAY_BEGIN<br>174 = SIGN_TYPE_REGULAR_END_OF_EXPRESSWAY<br>175 = SIGN_TYPE_REGULAR_PLAYGROUND_AREA_BEGIN <br>176 = SIGN_TYPE_REGULAR_END_OF_PLAYGROUND_AREA<br>200 = SIGN_TYPE_REGULAR_NO_PASSING_START<br>201 = SIGN_TYPE_REGULAR_END_OF_NO_PASSING<br>220 = SIGN_TYPE_ELECTRONIC_NO_PASSING_START<br>221 = SIGN_TYPE_ELECTRONIC_END_OF_NO_PASSING<br>254 = SIGN_TYPE_NONE_DETECTED<br>255 = SIGN_TYPE_INVALID"
			},
			{
				"name" : "vision_only_supplementary_sign_type",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = SUPP_SIGN_TYPE_NONE<br>1 = SUPP_SIGN_TYPE_RAIN<br>2 = SUPP_SIGN_TYPE_SNOW<br>3 = SUPP_SIGN_TYPE_TRAILER<br>4 = SUPP_SIGN_TYPE_TIME<br>5 = SUPP_SIGN_TYPE_ARROW_LEFT<br>6 = SUPP_SIGN_TYPE_ARROW_RIGHT<br>7 = SUPP_SIGN_TYPE_BEND_ARROW_LEFT<br>8 = SUPP_SIGN_TYPE_BEND_ARROW_RIGHT<br>9 = SUPP_SIGN_TYPE_TRUCK<br>10 = SUPP_SIGN_TYPE_DISTANCE_ARROW<br>11 = SUPP_SIGN_TYPE_WEIGHT<br>12 = SUPP_SIGN_TYPE_DISTANCE_IN<br>13 = SUPP_SIGN_TYPE_TRACTOR<br>14 = SUPP_SIGN_TYPE_SNOW_RAIN<br>15 = SUPP_SIGN_TYPE_SCHOOL<br>16 = SUPP_SIGN_TYPE_RAIN_CLOUD<br>17 = SUPP_SIGN_TYPE_FOG<br>18 = SUPP_SIGN_TYPE_HAZARDOUS_MATERIALS<br>19 = SUPP_SIGN_TYPE_NIGHT<br>20 = SUPP_SIGN_TYPE_GENERIC<br>21 = SUPP_SIGN_TYPE_RAPPEL<br>22 = SUPP_SIGN_TYPE_ZONE<br>255 = SUPP_SIGN_TYPE_INVALID"
			},
			{
				"name" : "sign_position_x",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "sign_position_y",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "sign_position_z",
				"data_type" : "float32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "filter_type",
				"data_type" : "uint8",
				"units" : "",
				"description" : "0 = FILTER_TYPE_NOT_FILTERED<br>1 = FILTER_TYPE_IRRELEVANT_TO_DRIVER<br>2 = FILTER_TYPE_ON_VEHICLE<br>3 = FILTER_TYPE_EMBEDDED"
			}]
		},
		{
			"name" : "/mobileye/parsed_tx/tsr_vision_only",
			"nickname" : "Mobileye / tsr_vision_only",
			"ROS_topic_name" : "/mobileye/parsed_tx/tsr_vision_only",
			"ROS_data_type" : "mobileye_560_660_msgs/TsrVisionOnly",
			"collection_rate" : "",
			"description" : "(Parsed)",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "vision_only_sign_type_display1",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "vision_only_supplementary_sign_type_display1",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "vision_only_sign_type_display2",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "vision_only_supplementary_sign_type_display2",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "vision_only_sign_type_display3",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "vision_only_supplementary_sign_type_display3",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "vision_only_sign_type_display4",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "vision_only_supplementary_sign_type_display4",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			}]
		},		
		{
			"name" : "/usb_cam/front/image",
			"nickname" : "usb_cam/front",
			"ROS_topic_name" : "/usb_cam/front/image",
			"ROS_data_type" : "sensor_msgs/CompressedImage (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "Image from the camera located at the front of the vehicle (looking forward).",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "format",
				"data_type" : "string",
				"units" : "",
				"description" : "Specifies format (JPG)"
			},
			{
				"name" : "data",
				"data_type" : "uint8[]",
				"units" : "",
				"description" : "Compressed image buffer"
			}]
		},
		{
			"name" : "/usb_cam/rear/image",
			"nickname" : "usb_cam/rear",
			"ROS_topic_name" : "/usb_cam/rear/image",
			"ROS_data_type" : "sensor_msgs/CompressedImage (AS ros_pkgs)",
			"collection_rate" : "",
			"description" : "Image from the camera located at the rear of the vehicle (looking backward).",
			"collected_as" : "",
			"data_table" : [{
				"name" : "header",
				"data_type" : [{
					"name" : "seq",
					"data_type" : "uint32",
					"units" : "",
					"description" : ""
				},
				{
					"name" : "stamp",
					"data_type" : [{
						"name" : "secs",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Seconds (stamp_secs) since epoch"
					},
					{
						"name" : "nsecs",
						"data_type" : "uint32",
						"units" : "ms",
						"description" : "Nanoseconds since stamp_secs"
					}],
					"units" : "",
					"description" : ""
				},
				{
					"name" : "frame_id",
					"data_type" : "string",
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "format",
				"data_type" : "string",
				"units" : "",
				"description" : "Specifies format (JPG)"
			},
			{
				"name" : "data",
				"data_type" : "uint8[]",
				"units" : "",
				"description" : "Compressed image buffer"
			}]
		}
	],
	"topics_v2v" : [
		{
			"name" : "/v2v_prism",
			"nickname" : "V2V",
			"ROS_topic_name" : "/v2v_prism",
			"ROS_data_type" : "std_msgs/String",
			"collection_rate" : "variable",
			"description" : "Collection topic for information sent from NADS V2V intermediary service (Prism). \"last_info\" data is dependent upon the capabilities/functionality of the remote vehicle. The below is a general look at the data chunk supplied by all NADS-instrumented V2V vehicles. Default values are noted in the Description column—if the default value is seen in recorded data, it can be assumed that the associated remote vehicle is not (or could not be) instrumented to get that value.",
			"collected_as" : "JSON string",
			"data_table" : [{
				"name" : "timestamp",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Vehicle time (UNIX epoch)"
			},
			{
				"name" : "vehicle_list",
				"data_type" : [{
					"name" : "traffic_vin",
					"data_type" : "string",
					"units" : "",
					"description" : "VIN"
				},
				{
					"name" : "vehicle_class",
					"data_type" : "uint8",
					"units" : "",
					"description" : "Internal classification ID of vehicle class<br>10 = BUS<br>20 = AGRICULTURAL_EQUIP"
				},
				{
					"name" : "cartesian_distance",
					"data_type" : "float32",
					"units" : "m",
					"description" : "Computed \"as the crow flies\" distance between the Transit and the external vehicle."
				},
				{
					"name" : "last_info",
					"data_type" : [{
						"name" : "VIN",
						"data_type" : "string",
						"units" : "",
						"description" : "VIN"
					},
					{
						"name" : "PC_Timestamp",
						"data_type" : "string",
						"units" : "",
						"description" : "Text timestamp from the remote vehicle main CPU"
					},
					{
						"name" : "GPS_Timestamp",
						"data_type" : "uint32",
						"units" : "s",
						"description" : "Timestamp from GPS fix onboard remote vehicle.<br>DEFAULT: 0"
					},
					{
						"name" : "GPS_SignalQuality",
						"data_type" : "uint8",
						"units" : "",
						"description" : "Index of GPS signal quality info.<br>DEFAULT: -1"
					},
					{
						"name" : "GPS_NumSats",
						"data_type" : "uint8",
						"units" : "",
						"description" : "Number of satellites used in GPS solution.<br>DEFAULT: 0"
					},
					{
						"name" : "GPS_Latitude",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "GPS_Longitude",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "GPS_Elevation",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "GPS_Heading",
						"data_type" : "float32",
						"units" : "deg",
						"description" : "RANGE: 0 ... 360"
					},
					{
						"name" : "CAN_Accelerator_Pedal_Pos",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Brake_Pedal_Pressure",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Steering_Wheel_Angle",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Transmission_Gear",
						"data_type" : "uint8",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Speed",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Engine_RPM",
						"data_type" : "uint8",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Acceleration",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Ignition",
						"data_type" : "uint8",
						"units" : "",
						"description" : "Ignition state<br>DEFAULT: -1<br>1 = OFF<br>2 = ACCESSORY<br>3 = ENGINE_ON"
					},
					{
						"name" : "CAN_Odometer",
						"data_type" : "float32",
						"units" : "miles",
						"description" : ""
					},
					{
						"name" : "CAN_Cruise_Control",
						"data_type" : "uint8",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Headlights",
						"data_type" : "uint8",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Headlights_Auto_Status",
						"data_type" : "uint8",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Brake_Light_Status",
						"data_type" : "uint8",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Fog_Lamp_Status",
						"data_type" : "uint8",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Seatbelt",
						"data_type" : "uint8",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Outside_Temp",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "CAN_Ext_Light_Status",
						"data_type" : "uint8",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "INFT_CPU_Temp",
						"data_type" : "float32",
						"units" : "",
						"description" : ""
					},
					{
						"name" : "ACCLRM_Acceleration",
						"data_type" : "float32[]",
						"units" : "",
						"description" : "DEFAULT: [0,0,0]"
					},
					{
						"name" : "CCGS_Running",
						"data_type" : "bool",
						"units" : "",
						"description" : "Video collection—remote vehicle is broadcasting at least one video stream.<br>DEFAULT: false"
					}],
					"units" : "",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			}]
		},
		{
			"name" : "/weather",
			"nickname" : "Weather",
			"ROS_topic_name" : "/weather",
			"ROS_data_type" : "std_msgs/String",
			"collection_rate" : "variable",
			"description" : "Collection topic for information requests made to the OpenWeather API (OW API), based upon GPS coordinates of the Transit.",
			"collected_as" : "JSON string",
			"data_table" : [{
				"name" : "timestamp",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Vehicle time (UNIX epoch)"
			},
			{
				"name" : "coord",
				"data_type" : [{
					"name" : "lon",
					"data_type" : "float32",
					"units" : "deg",
					"description" : "City geo location, longitude"
				},
				{
					"name" : "lat",
					"data_type" : "float32",
					"units" : "deg",
					"description" : "City geo location, latitude"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "weather",
				"data_type" : [{
					"name" : "id",
					"data_type" : "uint8",
					"units" : "",
					"description" : "Weather condition ID"
				},
				{
					"name" : "main",
					"data_type" : "string",
					"units" : "",
					"description" : "Group of weather parameters (Rain, Snow, Extreme etc.)"
				},
				{
					"name" : "description",
					"data_type" : "string",
					"units" : "",
					"description" : "Weather condition within the group (English)"
				},
				{
					"name" : "icon",
					"data_type" : "string",
					"units" : "",
					"description" : "Weather icon ID"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "base",
				"data_type" : "string",
				"units" : "",
				"description" : "OW API internal parameter"
			},
			{
				"name" : "main",
				"data_type" : [{
					"name" : "temp",
					"data_type" : "float32",
					"units" : "deg C",
					"description" : "Outside temperature"
				},
				{
					"name" : "feels_like",
					"data_type" : "float32",
					"units" : "deg C",
					"description" : "This temperature parameter accounts for the human perception of weather"
				},
				{
					"name" : "temp_min",
					"data_type" : "float32",
					"units" : "deg C",
					"description" : "Minimum observed temperature at the moment"
				},
				{
					"name" : "temp_max",
					"data_type" : "float32",
					"units" : "deg C",
					"description" : "Maximum observed temperature at the moment"
				},
				{
					"name" : "pressure",
					"data_type" : "uint8",
					"units" : "hPa",
					"description" : "Atmospheric pressure (on the sea level, if there is no sea_level or grnd_level data)"
				},
				{
					"name" : "humidity",
					"data_type" : "uint8",
					"units" : "%",
					"description" : ""
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "visibility",
				"data_type" : "uint32",
				"units" : "m",
				"description" : ""
			},
			{
				"name" : "wind",
				"data_type" : [{
					"name" : "speed",
					"data_type" : "float32",
					"units" : "m/s",
					"description" : "Wind speed"
				},
				{
					"name" : "deg",
					"data_type" : "uint8",
					"units" : "deg",
					"description" : "Wind direction (wind origin)"
				},
				{
					"name" : "gust",
					"data_type" : "float32",
					"units" : "m/s",
					"description" : "Wind gust"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "clouds",
				"data_type" : [{
					"name" : "all",
					"data_type" : "uint8",
					"units" : "%",
					"description" : "Cloudiness"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "rain",
				"data_type" : [{
					"name" : "1h",
					"data_type" : "uint8",
					"units" : "mm",
					"description" : "Rain volume for the last 1 hour"
				},
				{
					"name" : "3h",
					"data_type" : "uint8",
					"units" : "mm",
					"description" : "Rain volume for the last 3 hours"
				}],
				"units" : "",
				"description" : "(Only represented if rain is falling)"
			},
			{
				"name" : "snow",
				"data_type" : [{
					"name" : "1h",
					"data_type" : "uint8",
					"units" : "mm",
					"description" : "Snow volume for the last 1 hour"
				},
				{
					"name" : "3h",
					"data_type" : "uint8",
					"units" : "mm",
					"description" : "Snow volume for the last 3 hours"
				}],
				"units" : "",
				"description" : "(Only represented if snow is falling)"
			},
			{
				"name" : "dt",
				"data_type" : "uint32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "sys",
				"data_type" : [{
					"name" : "type",
					"data_type" : "uint8",
					"units" : "",
					"description" : "OW API internal parameter"
				},
				{
					"name" : "id",
					"data_type" : "uint8",
					"units" : "",
					"description" : "OW API internal parameter"
				},
				{
					"name" : "country",
					"data_type" : "string",
					"units" : "",
					"description" : "Country code"
				},
				{
					"name" : "sunrise",
					"data_type" : "uint32",
					"units" : "s",
					"description" : "Sunrise time, UNIX, UTC"
				},
				{
					"name" : "sunset",
					"data_type" : "uint32",
					"units" : "s",
					"description" : "Sunset time, UNIX, UTC"
				}],
				"units" : "",
				"description" : ""
			},
			{
				"name" : "timezone",
				"data_type" : "uint32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "id",
				"data_type" : "uint32",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "name",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "cod",
				"data_type" : "uint32",
				"units" : "",
				"description" : ""
			}]
		}
	],
	"topics_passenger_tablet_interface" : [
		{
			"name" : "/engagement",
			"nickname" : "Engagement",
			"ROS_topic_name" : "",
			"ROS_data_type" : "",
			"collection_rate" : "variable",
			"description" : "Log file from the Transit Information Server, containing actions taken by the system, passengers connected to the system using individual tablets, and the research assistant (RAS) administering surveys to participant tablets and triggering manual events on the central information display.",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "timestamp",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Vehicle time (UNIX epoch)"
			},
			{
				"name" : "originator",
				"data_type" : "uint16",
				"units" : "",
				"description" : "ID of the user (or system) taking the action.<br><br>-888 = SYSTEM<br>1-899 = Unique participants<br>900-999 = Safety drivers"
			},
			{
				"name" : "target",
				"data_type" : "uint16",
				"units" : "",
				"description" : "ID of the target of the action. (Blank if none)<br><br>0 = All connected participants"
			},
			{
				"name" : "action",
				"data_type" : "string",
				"units" : "",
				"description" : "What action was taken"
			}]
		}
	],
	"topics_physiological_data" : [
		{
			"name" : "/empatica/temp",
			"nickname" : "Empatica / Temperature",
			"collection_rate" : "4 Hz",
			"description" : "Physiological data from an Empatica E4 wearable. Baseline collection duration is ~10 minutes.<br><br>Since the sensors for each measurement happen at different intervals, any given row may include one or more of the following variables.<br><br>Each “session” from each device produces seven (7) CSV export files. Native CSV files are in the following format:<br><br>With the exception of the IBI.csv and tags.csv files, the first row is the initial time of the session expressed as UNIX timestamp in UTC. The second row is the sample rate expressed in Hz.",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "timestamp",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Vehicle time (UNIX epoch)"
			},
			{
				"name" : "drive_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "participant_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "temp",
				"data_type" : "float32",
				"units" : "deg C",
				"description" : "Measured skin temperature."
			},
			{
				"name" : "is_baseline",
				"data_type" : "bit",
				"units" : "",
				"description" : "1 - Baseline data<br>0 - Collection data"
			}]
		},
		{
			"name" : "/empatica/acc",
			"nickname" : "Empatica / Accelerometer",
			"collection_rate" : "32 Hz",
			"description" : "Physiological data from an Empatica E4 wearable. Baseline collection. (Duration: ~10 minutes)<br><br>Since the sensors for each measurement happen at different intervals, any given row may include one or more of the following variables.<br><br>Each “session” from each device produces seven (7) CSV export files. Native CSV files are in the following format:<br><br>With the exception of the IBI.csv and tags.csv files, the first row is the initial time of the session expressed as UNIX timestamp in UTC. The second row is the sample rate expressed in Hz.",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "timestamp",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Vehicle time (UNIX epoch)"
			},
			{
				"name" : "drive_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "participant_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "acc_x",
				"data_type" : "float32[3]",
				"units" : "1/64g",
				"description" : "Data from 3-axis accelerometer sensor (X axis). The accelerometer is configured to measure acceleration in the range [-2g, 2g]. Data from x, y, and z axis are respectively in first, second, and third column."
			},
			{
				"name" : "acc_y",
				"data_type" : "float32[3]",
				"units" : "1/64g",
				"description" : "Data from 3-axis accelerometer sensor (Y axis). The accelerometer is configured to measure acceleration in the range [-2g, 2g]. Data from x, y, and z axis are respectively in first, second, and third column."
			},
			{
				"name" : "acc_z",
				"data_type" : "float32[3]",
				"units" : "1/64g",
				"description" : "Data from 3-axis accelerometer sensor (Z axis). The accelerometer is configured to measure acceleration in the range [-2g, 2g]. Data from x, y, and z axis are respectively in first, second, and third column."
			},
			{
				"name" : "is_baseline",
				"data_type" : "bit",
				"units" : "",
				"description" : "1 - Baseline data<br>0 - Collection data"
			}]
		},
		{
			"name" : "/empatica/bvp",
			"nickname" : "Empatica / BVP",
			"collection_rate" : "4 Hz",
			"description" : "Physiological data from an Empatica E4 wearable. Baseline collection. (Duration: ~10 minutes)<br><br>Since the sensors for each measurement happen at different intervals, any given row may include one or more of the following variables.<br><br>Each “session” from each device produces seven (7) CSV export files. Native CSV files are in the following format:<br><br>With the exception of the IBI.csv and tags.csv files, the first row is the initial time of the session expressed as UNIX timestamp in UTC. The second row is the sample rate expressed in Hz.",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "timestamp",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Vehicle time (UNIX epoch)"
			},
			{
				"name" : "drive_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "participant_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "bvp",
				"data_type" : "float32",
				"units" : "",
				"description" : "Data from photoplethysmograph."
			},
			{
				"name" : "is_baseline",
				"data_type" : "bit",
				"units" : "",
				"description" : "1 - Baseline data<br>0 - Collection data"
			}]
		},
		{
			"name" : "/empatica/eda",
			"nickname" : "Empatica / EDA",
			"collection_rate" : "4 Hz",
			"description" : "Physiological data from an Empatica E4 wearable. Baseline collection. (Duration: ~10 minutes)<br><br>Since the sensors for each measurement happen at different intervals, any given row may include one or more of the following variables.<br><br>Each “session” from each device produces seven (7) CSV export files. Native CSV files are in the following format:<br><br>With the exception of the IBI.csv and tags.csv files, the first row is the initial time of the session expressed as UNIX timestamp in UTC. The second row is the sample rate expressed in Hz.",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "timestamp",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Vehicle time (UNIX epoch)"
			},
			{
				"name" : "drive_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "participant_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "eda",
				"data_type" : "float32",
				"units" : "μS (microsiemens)",
				"description" : "Data from the electrodermal activity sensor."
			},
			{
				"name" : "is_baseline",
				"data_type" : "bit",
				"units" : "",
				"description" : "1 - Baseline data<br>0 - Collection data"
			}]
		},
		{
			"name" : "/empatica/hr",
			"nickname" : "Empatica / Heart rate",
			"collection_rate" : "1 Hz",
			"description" : "Physiological data from an Empatica E4 wearable. Baseline collection. (Duration: ~10 minutes)<br><br>Since the sensors for each measurement happen at different intervals, any given row may include one or more of the following variables.<br><br>Each “session” from each device produces seven (7) CSV export files. Native CSV files are in the following format:<br><br>With the exception of the IBI.csv and tags.csv files, the first row is the initial time of the session expressed as UNIX timestamp in UTC. The second row is the sample rate expressed in Hz.",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "timestamp",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Vehicle time (UNIX epoch)"
			},
			{
				"name" : "drive_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "participant_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "hr",
				"data_type" : "float32",
				"units" : "Heart beats / min",
				"description" : "Average heart rate extracted from the BVP signal"
			},
			{
				"name" : "is_baseline",
				"data_type" : "bit",
				"units" : "",
				"description" : "1 - Baseline data<br>0 - Collection data"
			}]
		},
		{
			"name" : "/empatica/ibi",
			"nickname" : "Empatica / Heart beat interval",
			"collection_rate" : "variable",
			"description" : "Physiological data from an Empatica E4 wearable. Baseline collection. (Duration: ~10 minutes)<br><br>Since the sensors for each measurement happen at different intervals, any given row may include one or more of the following variables.<br><br>Each “session” from each device produces seven (7) CSV export files. Native CSV files are in the following format:<br><br>With the exception of the IBI.csv and tags.csv files, the first row is the initial time of the session expressed as UNIX timestamp in UTC. The second row is the sample rate expressed in Hz.",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "timestamp",
				"data_type" : "uint32",
				"units" : "",
				"description" : "Vehicle time (UNIX epoch)"
			},
			{
				"name" : "drive_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "participant_id",
				"data_type" : "uint16",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "ibi",
				"data_type" : "float32[2]",
				"units" : "s",
				"description" : "Time between individuals heart beats extracted from the BVP signal. No sample rate is needed for this file.<br><br>The first column is the time (respect to the initial time) of the detected inter-beat interval expressed in seconds (s).<br><br>The second column is the duration in seconds (s) of the detected inter-beat interval (i.e., the distance in seconds from the previous beat)."
			},
			{
				"name" : "is_baseline",
				"data_type" : "bit",
				"units" : "",
				"description" : "1 - Baseline data<br>0 - Collection data"
			}]
		}
	],
	"topics_survey" : [
		{
			"name" : "/survey/demographic",
			"nickname" : "Survey / Demographic",
			"ROS_data_type" : "",
			"collection_rate" : "",
			"description" : "[Survey key](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_Demographic.pdf)",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "StartDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time start of survey (America/Denver timezone)"
			},
			{
				"name" : "EndDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time end of survey (America/Denver timezone)"
			},
			{
				"name" : "Status",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "IPAddress",
				"data_type" : "string",
				"units" : "",
				"description" : "IP address of respondent"
			},
			{
				"name" : "Progress",
				"data_type" : "uint8",
				"units" : "%",
				"description" : ""
			},
			{
				"name" : "Duration",
				"data_type" : "uint8",
				"units" : "s",
				"description" : "Duration spent in answering full survey"
			},
			{
				"name" : "Finished",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecordedDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time of survey being recorded (internal Qualtrics timing)"
			},
			{
				"name" : "ResponseId",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecipientLastName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient last name (not used)"
			},
			{
				"name" : "RecipientFirstName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient first name (not used)"
			},
			{
				"name" : "RecipientEmail",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient email address (not used)"
			},
			{
				"name" : "ExternalReference",
				"data_type" : "string",
				"units" : "",
				"description" : "External Data Reference (not used)"
			},
			{
				"name" : "LocationLatitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response latitude"
			},
			{
				"name" : "LocationLongitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response longitude"
			},
			{
				"name" : "DistributionChannel",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "UserLanguage",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "Q1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "What is your gender?"
			},
			{
				"name" : "Q2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "What is your age?"
			},
			{
				"name" : "Q3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "What is the highest level of education you have completed?"
			},
			{
				"name" : "Q4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "What is your household income?"
			},
			{
				"name" : "Q5",
				"data_type" : "uint32",
				"units" : "",
				"description" : "What is your zip code?"
			},
			{
				"name" : "Q6",
				"data_type" : "uint8",
				"units" : "",
				"description" : "RUCC code (to be entered by the researcher) - RUCC"
			},
			{
				"name" : "Q7",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Do you have a valid driver's license?"
			},
			{
				"name" : "Q8",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Do you have any restrictions on your license? - Selected Choice"
			},
			{
				"name" : "Q8_2_TEXT",
				"data_type" : "string",
				"units" : "",
				"description" : "Do you have any restrictions on your license? - Yes (please indicate what those restrictions are below) - Text"
			},
			{
				"name" : "Q9",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Do you own or have access to a vehicle?"
			},
			{
				"name" : "Q10",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Approximately how many miles did you drive last year?"
			},
			{
				"name" : "Q11_1",
				"data_type" : "uint16",
				"units" : "",
				"description" : "What is the year, make and model of your vehicle?<br><br>If you have more than one, please provide information about the one you drive most often. - Vehicle Model Year"
			},
			{
				"name" : "Q11_2",
				"data_type" : "string",
				"units" : "",
				"description" : "What is the year, make and model of your vehicle?<br><br>If you have more than one, please provide information about the one you drive most often. - Vehicle Make (e.g., Ford)"
			},
			{
				"name" : "Q11_3",
				"data_type" : "string",
				"units" : "",
				"description" : "What is the year, make and model of your vehicle?<br><br>If you have more than one, please provide information about the one you drive most often. - Vehicle Model (e.g., Escape)"
			},
			{
				"name" : "Q12_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Does this vehicle have the following features: - Adaptive Cruise Control - This system tracks the vehicle directly in front of the driver and slows down or speeds up based on the driver's chosen speed and following distance."
			},
			{
				"name" : "Q12_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Does this vehicle have the following features: - Lane Keeping or Lane Centering - These systems are designed to either automatically guide the vehicle back into the lane if the vehicle has begun to drift out of it or to keep the vehicle in the center of the lane."
			},
			{
				"name" : "Q13",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I use my Adaptive Cruise Control system..."
			},
			{
				"name" : "Q14",
				"data_type" : "uint8",
				"units" : "",
				"description" : "You indicated that you do not use your Adaptive Cruise Control system. Please check all that apply to indicate why you do not use the technology."
			},
			{
				"name" : "Q15",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I use my Lane Keeping or Lane Centering system..."
			},
			{
				"name" : "Q16",
				"data_type" : "uint8",
				"units" : "",
				"description" : "You indicated that you do not use your Lane Keeping or Lane Centering system. Please check all that apply to indicate why you do not use the technology."
			},
			{
				"name" : "Q17_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "In a typical month, how often do you... - Drive yourself"
			},
			{
				"name" : "Q17_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "In a typical month, how often do you... - Get a ride from a family member who lives with you"
			},
			{
				"name" : "Q17_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "In a typical month, how often do you... - Get a ride from a family member who does not live with you"
			},
			{
				"name" : "Q17_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "In a typical month, how often do you... - Get a ride from a friend"
			},
			{
				"name" : "Q18_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How many times in the last month have you used the following public transportation services? - City or county bus (fixed route)"
			},
			{
				"name" : "Q18_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How many times in the last month have you used the following public transportation services? - Paratransit services (on demand)"
			},
			{
				"name" : "Q19",
				"data_type" : "uint8[]",
				"units" : "",
				"description" : "What are the challenges associated with using public transportation (e.g., traveling by bus/paratransit)? (check all that apply) - Selected Choice"
			},
			{
				"name" : "Q19_7_TEXT",
				"data_type" : "string",
				"units" : "",
				"description" : "What are the challenges associated with using public transportation (e.g., traveling by bus/paratransit)? (check all that apply) - Other (please describe) - Text"
			},
			{
				"name" : "Q20_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How many times in the last month have you used the following private transportation services? - Taxi"
			},
			{
				"name" : "Q20_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How many times in the last month have you used the following private transportation services? - Van/shuttle service"
			},
			{
				"name" : "Q20_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How many times in the last month have you used the following private transportation services? - Transportation services (e.g., Uber or Lyft)"
			},
			{
				"name" : "Q21",
				"data_type" : "uint8[]",
				"units" : "",
				"description" : "What are the challenges associated with traveling by taxi, van/shuttle services or other private transportation services like Uber and Lyft? (check all that apply) - Selected Choice"
			},
			{
				"name" : "Q21_11_TEXT",
				"data_type" : "string",
				"units" : "",
				"description" : "What are the challenges associated with traveling by taxi, van/shuttle services or other private transportation services like Uber and Lyft? (check all that apply) - Other (please describe) - Text"
			},
			{
				"name" : "Q22_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "We would like to ask you some questions about your physical, emotional and mental health. - Do you have difficulty hearing?"
			},
			{
				"name" : "Q22_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "We would like to ask you some questions about your physical, emotional and mental health. - Do you have difficulty seeing even when wearing glasses?"
			},
			{
				"name" : "Q22_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "We would like to ask you some questions about your physical, emotional and mental health. - Do you have trouble walking or climbing stairs?"
			},
			{
				"name" : "Q22_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "We would like to ask you some questions about your physical, emotional and mental health. - Do you use a wheelchair?"
			},
			{
				"name" : "Q22_5",
				"data_type" : "uint8",
				"units" : "",
				"description" : "We would like to ask you some questions about your physical, emotional and mental health. - Do you use a walker, cane or crutches?"
			},
			{
				"name" : "Q22_6",
				"data_type" : "uint8",
				"units" : "",
				"description" : "We would like to ask you some questions about your physical, emotional and mental health. - Do you have serious difficulty concentrating, remembering or making decisions?"
			},
			{
				"name" : "Q22_7",
				"data_type" : "uint8",
				"units" : "",
				"description" : "We would like to ask you some questions about your physical, emotional and mental health. - Do you need the assistance of others to complete everyday tasks such as dressing, bathing or getting around the house?"
			},
			{
				"name" : "Q22_8",
				"data_type" : "uint8",
				"units" : "",
				"description" : "We would like to ask you some questions about your physical, emotional and mental health. - Do you have difficulty doing errands alone, such as visiting a doctor's office or shopping?"
			},
			{
				"name" : "Q23",
				"data_type" : "uint8",
				"units" : "",
				"description" : "When it comes to trying a new technology I am generally..."
			},
			{
				"name" : "Q24_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate whether you own or use each of the following technologies. - Cell phone (i.e., a portable, cordless telephone for use in a cellular system)"
			},
			{
				"name" : "Q24_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate whether you own or use each of the following technologies. - Internet"
			},
			{
				"name" : "Q24_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate whether you own or use each of the following technologies. - Smart phone (i.e., a phone that performs many of the functions of a computer, having a touchscreen and internet access)"
			},
			{
				"name" : "Q24_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate whether you own or use each of the following technologies. - Desktop/laptop computer"
			},
			{
				"name" : "Q24_5",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate whether you own or use each of the following technologies. - Social media (e.g., Facebook, Twitter, Instagram, or YouTube)"
			},
			{
				"name" : "Q24_6",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate whether you own or use each of the following technologies. - Tablet"
			},
			{
				"name" : "Q25_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How do you feel about the following statements? - I like to use technology to make tasks easier for me"
			},
			{
				"name" : "Q25_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How do you feel about the following statements? - I have bad experiences when I try to use technology instead of doing things myself"
			},
			{
				"name" : "Q25_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How do you feel about the following statements? - I want a car with all of the latest technology features"
			},
			{
				"name" : "subject_number",
				"data_type" : "uint16",
				"units" : "",
				"description" : "Participant ID number"
			}]
		},
		{
			"name" : "/survey/predrive",
			"nickname" : "Survey / Pre-Drive",
			"ROS_data_type" : "",
			"collection_rate" : "",
			"description" : "[Survey key](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_PreDrive.pdf)",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "StartDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time start of survey (America/Denver timezone)"
			},
			{
				"name" : "EndDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time end of survey (America/Denver timezone)"
			},
			{
				"name" : "Status",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "IPAddress",
				"data_type" : "string",
				"units" : "",
				"description" : "IP address of respondent"
			},
			{
				"name" : "Progress",
				"data_type" : "uint8",
				"units" : "%",
				"description" : ""
			},
			{
				"name" : "Duration",
				"data_type" : "uint8",
				"units" : "s",
				"description" : "Duration spent in answering full survey"
			},
			{
				"name" : "Finished",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecordedDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time of survey being recorded (internal Qualtrics timing)"
			},
			{
				"name" : "ResponseId",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecipientLastName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient last name (not used)"
			},
			{
				"name" : "RecipientFirstName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient first name (not used)"
			},
			{
				"name" : "RecipientEmail",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient email address (not used)"
			},
			{
				"name" : "ExternalReference",
				"data_type" : "string",
				"units" : "",
				"description" : "External Data Reference (not used)"
			},
			{
				"name" : "LocationLatitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response latitude"
			},
			{
				"name" : "LocationLongitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response longitude"
			},
			{
				"name" : "DistributionChannel",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "UserLanguage",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "Q1_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you feel about each one of the statements. - Driving without accidents is mainly a matter of luck."
			},
			{
				"name" : "Q1_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you feel about each one of the statements. - Accidents usually happen because of unexpected events that occur during driving."
			},
			{
				"name" : "Q1_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you feel about each one of the statements. - Accidents usually happen because of driver error, such as driver distraction"
			},
			{
				"name" : "Q1_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you feel about each one of the statements. - It is difficult to prevent accidents when the driving conditions are difficult, such as darkness, rain, or a narrow road with many turns."
			},
			{
				"name" : "Q1_5",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you feel about each one of the statements. - Most accidents happen because of lack of knowledge or laziness on the part of the driver"
			},
			{
				"name" : "Q3_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I believe that highly automated vehicles are reliable."
			},
			{
				"name" : "Q3_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I am suspicious of highly automated vehicles."
			},
			{
				"name" : "Q3_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I can trust highly automated vehicles."
			},
			{
				"name" : "Q3_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I believe that highly automated vehicles will work the way I expect them to."
			},
			{
				"name" : "Q4_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I am not worried about riding in a highly automated vehicle."
			},
			{
				"name" : "Q4_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I believe that highly automated vehicles might cause crashes."
			},
			{
				"name" : "Q4_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I believe that highly automated vehicles are safer than manually driven vehicles."
			},
			{
				"name" : "Q4_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I feel safe riding in a highly automated vehicle."
			},
			{
				"name" : "Q4_5",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I am afraid to ride in a highly automated vehicle."
			},
			{
				"name" : "Q4_6",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I believe highly automated vehicles are dangerous."
			},
			{
				"name" : "Q5_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive on the interstate/highway"
			},
			{
				"name" : "Q5_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive on city streets"
			},
			{
				"name" : "Q5_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive in congested traffic"
			},
			{
				"name" : "Q5_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive in residential areas"
			},
			{
				"name" : "Q5_5",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive in areas with lots of pedestrian traffic"
			},
			{
				"name" : "Q5_6",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive on gravel roads"
			},
			{
				"name" : "Q5_7",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive through construction zones"
			},
			{
				"name" : "Q6_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - navigate a parking lot and park itself"
			},
			{
				"name" : "Q6_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - operate in closed areas (e.g., airports, campuses, retirement villages)"
			},
			{
				"name" : "Q6_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - operate without a steering wheel or other controls"
			},
			{
				"name" : "Q6_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - maintain a safe following distance"
			},
			{
				"name" : "Q6_5",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - respond to traffic light/sign"
			},
			{
				"name" : "Q6_6",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - stay within the correct lane"
			},
			{
				"name" : "Q6_7",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - parallel park"
			},
			{
				"name" : "Q7_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How concerned are you about the following issues related to highly automated vehicles? - the safety consequences of equipment or system failure"
			},
			{
				"name" : "Q7_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How concerned are you about the following issues related to highly automated vehicles? - its ability to interact with vehicles that are driven by humans"
			},
			{
				"name" : "Q7_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How concerned are you about the following issues related to highly automated vehicles? - its ability to interact with pedestrians and bicyclists"
			},
			{
				"name" : "Q7_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How concerned are you about the following issues related to highly automated vehicles? - system performance in poor weather"
			},
			{
				"name" : "Q7_5",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How concerned are you about the following issues related to highly automated vehicles? - the system being confused by unexpected situations"
			},
			{
				"name" : "Q7_6",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How concerned are you about the following issues related to highly automated vehicles? - the system not driving as well as human drivers"
			},
			{
				"name" : "Q8_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I am open to the idea of riding in a highly automated vehicle."
			},
			{
				"name" : "Q8_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - Highly automated vehicles will allow me to stay active."
			},
			{
				"name" : "Q8_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - Highly automated vehicles will allow me to stay involved in my community."
			},
			{
				"name" : "Q8_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - Highly automated vehicles will enhance my quality of life/well-being."
			},
			{
				"name" : "subject_number",
				"data_type" : "uint16",
				"units" : "",
				"description" : "Participant ID number"
			}]
		},
		{
			"name" : "/survey/drive_rp_0",
			"nickname" : "Survey / Anxiety Rating / Point 0",
			"ROS_data_type" : "",
			"collection_rate" : "",
			"description" : "[Survey key](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_AnxietyRatingPoint.pdf)",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "StartDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time start of survey (America/Denver timezone)"
			},
			{
				"name" : "EndDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time end of survey (America/Denver timezone)"
			},
			{
				"name" : "Status",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "IPAddress",
				"data_type" : "string",
				"units" : "",
				"description" : "IP address of respondent"
			},
			{
				"name" : "Progress",
				"data_type" : "uint8",
				"units" : "%",
				"description" : ""
			},
			{
				"name" : "Duration",
				"data_type" : "uint8",
				"units" : "s",
				"description" : "Duration spent in answering full survey"
			},
			{
				"name" : "Finished",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecordedDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time of survey being recorded (internal Qualtrics timing)"
			},
			{
				"name" : "ResponseId",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecipientLastName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient last name (not used)"
			},
			{
				"name" : "RecipientFirstName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient first name (not used)"
			},
			{
				"name" : "RecipientEmail",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient email address (not used)"
			},
			{
				"name" : "ExternalReference",
				"data_type" : "string",
				"units" : "",
				"description" : "External Data Reference (not used)"
			},
			{
				"name" : "LocationLatitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response latitude"
			},
			{
				"name" : "LocationLongitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response longitude"
			},
			{
				"name" : "DistributionChannel",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "UserLanguage",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "Q1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please rate your current level of anxiety. - Point 0 (Pre-Drive)"
			},
			{
				"name" : "subject_number",
				"data_type" : "uint16",
				"units" : "",
				"description" : "Participant ID number"
			}]
		},
		{
			"name" : "/survey/drive_rp_1",
			"nickname" : "Survey / Anxiety Rating / Point 1",
			"ROS_data_type" : "",
			"collection_rate" : "",
			"description" : "[Survey key](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_AnxietyRatingPoint.pdf)",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "StartDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time start of survey (America/Denver timezone)"
			},
			{
				"name" : "EndDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time end of survey (America/Denver timezone)"
			},
			{
				"name" : "Status",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "IPAddress",
				"data_type" : "string",
				"units" : "",
				"description" : "IP address of respondent"
			},
			{
				"name" : "Progress",
				"data_type" : "uint8",
				"units" : "%",
				"description" : ""
			},
			{
				"name" : "Duration",
				"data_type" : "uint8",
				"units" : "s",
				"description" : "Duration spent in answering full survey"
			},
			{
				"name" : "Finished",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecordedDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time of survey being recorded (internal Qualtrics timing)"
			},
			{
				"name" : "ResponseId",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecipientLastName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient last name (not used)"
			},
			{
				"name" : "RecipientFirstName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient first name (not used)"
			},
			{
				"name" : "RecipientEmail",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient email address (not used)"
			},
			{
				"name" : "ExternalReference",
				"data_type" : "string",
				"units" : "",
				"description" : "External Data Reference (not used)"
			},
			{
				"name" : "LocationLatitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response latitude"
			},
			{
				"name" : "LocationLongitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response longitude"
			},
			{
				"name" : "DistributionChannel",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "UserLanguage",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "Q1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please rate your current level of anxiety. - Point 0 (Pre-Drive)"
			},
			{
				"name" : "subject_number",
				"data_type" : "uint16",
				"units" : "",
				"description" : "Participant ID number"
			}]
		},
		{
			"name" : "/survey/drive_rp_2",
			"nickname" : "Survey / Anxiety Rating / Point 2",
			"ROS_data_type" : "",
			"collection_rate" : "",
			"description" : "[Survey key](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_AnxietyRatingPoint.pdf)",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "StartDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time start of survey (America/Denver timezone)"
			},
			{
				"name" : "EndDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time end of survey (America/Denver timezone)"
			},
			{
				"name" : "Status",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "IPAddress",
				"data_type" : "string",
				"units" : "",
				"description" : "IP address of respondent"
			},
			{
				"name" : "Progress",
				"data_type" : "uint8",
				"units" : "%",
				"description" : ""
			},
			{
				"name" : "Duration",
				"data_type" : "uint8",
				"units" : "s",
				"description" : "Duration spent in answering full survey"
			},
			{
				"name" : "Finished",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecordedDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time of survey being recorded (internal Qualtrics timing)"
			},
			{
				"name" : "ResponseId",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecipientLastName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient last name (not used)"
			},
			{
				"name" : "RecipientFirstName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient first name (not used)"
			},
			{
				"name" : "RecipientEmail",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient email address (not used)"
			},
			{
				"name" : "ExternalReference",
				"data_type" : "string",
				"units" : "",
				"description" : "External Data Reference (not used)"
			},
			{
				"name" : "LocationLatitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response latitude"
			},
			{
				"name" : "LocationLongitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response longitude"
			},
			{
				"name" : "DistributionChannel",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "UserLanguage",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "Q1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please rate your current level of anxiety. - Point 0 (Pre-Drive)"
			},
			{
				"name" : "subject_number",
				"data_type" : "uint16",
				"units" : "",
				"description" : "Participant ID number"
			}]
		},
		{
			"name" : "/survey/drive_rp_3",
			"nickname" : "Survey / Anxiety Rating / Point 3",
			"ROS_data_type" : "",
			"collection_rate" : "",
			"description" : "[Survey key](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_AnxietyRatingPoint.pdf)",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "StartDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time start of survey (America/Denver timezone)"
			},
			{
				"name" : "EndDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time end of survey (America/Denver timezone)"
			},
			{
				"name" : "Status",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "IPAddress",
				"data_type" : "string",
				"units" : "",
				"description" : "IP address of respondent"
			},
			{
				"name" : "Progress",
				"data_type" : "uint8",
				"units" : "%",
				"description" : ""
			},
			{
				"name" : "Duration",
				"data_type" : "uint8",
				"units" : "s",
				"description" : "Duration spent in answering full survey"
			},
			{
				"name" : "Finished",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecordedDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time of survey being recorded (internal Qualtrics timing)"
			},
			{
				"name" : "ResponseId",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecipientLastName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient last name (not used)"
			},
			{
				"name" : "RecipientFirstName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient first name (not used)"
			},
			{
				"name" : "RecipientEmail",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient email address (not used)"
			},
			{
				"name" : "ExternalReference",
				"data_type" : "string",
				"units" : "",
				"description" : "External Data Reference (not used)"
			},
			{
				"name" : "LocationLatitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response latitude"
			},
			{
				"name" : "LocationLongitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response longitude"
			},
			{
				"name" : "DistributionChannel",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "UserLanguage",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "Q1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please rate your current level of anxiety. - Point 0 (Pre-Drive)"
			},
			{
				"name" : "subject_number",
				"data_type" : "uint16",
				"units" : "",
				"description" : "Participant ID number"
			}]
		},
		{
			"name" : "/survey/drive_rp_4",
			"nickname" : "Survey / Anxiety Rating / Point 4",
			"ROS_data_type" : "",
			"collection_rate" : "",
			"description" : "[Survey key](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_AnxietyRatingPoint.pdf)",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "StartDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time start of survey (America/Denver timezone)"
			},
			{
				"name" : "EndDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time end of survey (America/Denver timezone)"
			},
			{
				"name" : "Status",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "IPAddress",
				"data_type" : "string",
				"units" : "",
				"description" : "IP address of respondent"
			},
			{
				"name" : "Progress",
				"data_type" : "uint8",
				"units" : "%",
				"description" : ""
			},
			{
				"name" : "Duration",
				"data_type" : "uint8",
				"units" : "s",
				"description" : "Duration spent in answering full survey"
			},
			{
				"name" : "Finished",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecordedDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time of survey being recorded (internal Qualtrics timing)"
			},
			{
				"name" : "ResponseId",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecipientLastName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient last name (not used)"
			},
			{
				"name" : "RecipientFirstName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient first name (not used)"
			},
			{
				"name" : "RecipientEmail",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient email address (not used)"
			},
			{
				"name" : "ExternalReference",
				"data_type" : "string",
				"units" : "",
				"description" : "External Data Reference (not used)"
			},
			{
				"name" : "LocationLatitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response latitude"
			},
			{
				"name" : "LocationLongitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response longitude"
			},
			{
				"name" : "DistributionChannel",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "UserLanguage",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "Q1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please rate your current level of anxiety. - Point 0 (Pre-Drive)"
			},
			{
				"name" : "subject_number",
				"data_type" : "uint16",
				"units" : "",
				"description" : "Participant ID number"
			}]
		},
		{
			"name" : "/survey/drive_rp_5",
			"nickname" : "Survey / Anxiety Rating / Point 5",
			"ROS_data_type" : "",
			"collection_rate" : "",
			"description" : "[Survey key](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_AnxietyRatingPoint.pdf)",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "StartDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time start of survey (America/Denver timezone)"
			},
			{
				"name" : "EndDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time end of survey (America/Denver timezone)"
			},
			{
				"name" : "Status",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "IPAddress",
				"data_type" : "string",
				"units" : "",
				"description" : "IP address of respondent"
			},
			{
				"name" : "Progress",
				"data_type" : "uint8",
				"units" : "%",
				"description" : ""
			},
			{
				"name" : "Duration",
				"data_type" : "uint8",
				"units" : "s",
				"description" : "Duration spent in answering full survey"
			},
			{
				"name" : "Finished",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecordedDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time of survey being recorded (internal Qualtrics timing)"
			},
			{
				"name" : "ResponseId",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecipientLastName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient last name (not used)"
			},
			{
				"name" : "RecipientFirstName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient first name (not used)"
			},
			{
				"name" : "RecipientEmail",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient email address (not used)"
			},
			{
				"name" : "ExternalReference",
				"data_type" : "string",
				"units" : "",
				"description" : "External Data Reference (not used)"
			},
			{
				"name" : "LocationLatitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response latitude"
			},
			{
				"name" : "LocationLongitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response longitude"
			},
			{
				"name" : "DistributionChannel",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "UserLanguage",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "Q1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please rate your current level of anxiety. - Point 0 (Pre-Drive)"
			},
			{
				"name" : "subject_number",
				"data_type" : "uint16",
				"units" : "",
				"description" : "Participant ID number"
			}]
		},
		{
			"name" : "/survey/drive_rp_6",
			"nickname" : "Survey / Anxiety Rating / Point 6",
			"ROS_data_type" : "",
			"collection_rate" : "",
			"description" : "[Survey key](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_AnxietyRatingPoint.pdf)",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "StartDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time start of survey (America/Denver timezone)"
			},
			{
				"name" : "EndDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time end of survey (America/Denver timezone)"
			},
			{
				"name" : "Status",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "IPAddress",
				"data_type" : "string",
				"units" : "",
				"description" : "IP address of respondent"
			},
			{
				"name" : "Progress",
				"data_type" : "uint8",
				"units" : "%",
				"description" : ""
			},
			{
				"name" : "Duration",
				"data_type" : "uint8",
				"units" : "s",
				"description" : "Duration spent in answering full survey"
			},
			{
				"name" : "Finished",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecordedDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time of survey being recorded (internal Qualtrics timing)"
			},
			{
				"name" : "ResponseId",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecipientLastName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient last name (not used)"
			},
			{
				"name" : "RecipientFirstName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient first name (not used)"
			},
			{
				"name" : "RecipientEmail",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient email address (not used)"
			},
			{
				"name" : "ExternalReference",
				"data_type" : "string",
				"units" : "",
				"description" : "External Data Reference (not used)"
			},
			{
				"name" : "LocationLatitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response latitude"
			},
			{
				"name" : "LocationLongitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response longitude"
			},
			{
				"name" : "DistributionChannel",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "UserLanguage",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "Q1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please rate your current level of anxiety. - Point 0 (Pre-Drive)"
			},
			{
				"name" : "subject_number",
				"data_type" : "uint16",
				"units" : "",
				"description" : "Participant ID number"
			}]
		},
		{
			"name" : "/survey/drive_rp_7",
			"nickname" : "Survey / Anxiety Rating / Point 7",
			"ROS_data_type" : "",
			"collection_rate" : "",
			"description" : "[Survey key](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_AnxietyRatingPoint.pdf)",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "StartDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time start of survey (America/Denver timezone)"
			},
			{
				"name" : "EndDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time end of survey (America/Denver timezone)"
			},
			{
				"name" : "Status",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "IPAddress",
				"data_type" : "string",
				"units" : "",
				"description" : "IP address of respondent"
			},
			{
				"name" : "Progress",
				"data_type" : "uint8",
				"units" : "%",
				"description" : ""
			},
			{
				"name" : "Duration",
				"data_type" : "uint8",
				"units" : "s",
				"description" : "Duration spent in answering full survey"
			},
			{
				"name" : "Finished",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecordedDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time of survey being recorded (internal Qualtrics timing)"
			},
			{
				"name" : "ResponseId",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecipientLastName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient last name (not used)"
			},
			{
				"name" : "RecipientFirstName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient first name (not used)"
			},
			{
				"name" : "RecipientEmail",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient email address (not used)"
			},
			{
				"name" : "ExternalReference",
				"data_type" : "string",
				"units" : "",
				"description" : "External Data Reference (not used)"
			},
			{
				"name" : "LocationLatitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response latitude"
			},
			{
				"name" : "LocationLongitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response longitude"
			},
			{
				"name" : "DistributionChannel",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "UserLanguage",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "Q1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please rate your current level of anxiety. - Point 0 (Pre-Drive)"
			},
			{
				"name" : "subject_number",
				"data_type" : "uint16",
				"units" : "",
				"description" : "Participant ID number"
			}]
		},
		{
			"name" : "/survey/drive_rp_8",
			"nickname" : "Survey / Anxiety Rating / Point 8",
			"ROS_data_type" : "",
			"collection_rate" : "",
			"description" : "[Survey key](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_AnxietyRatingPoint.pdf)",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "StartDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time start of survey (America/Denver timezone)"
			},
			{
				"name" : "EndDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time end of survey (America/Denver timezone)"
			},
			{
				"name" : "Status",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "IPAddress",
				"data_type" : "string",
				"units" : "",
				"description" : "IP address of respondent"
			},
			{
				"name" : "Progress",
				"data_type" : "uint8",
				"units" : "%",
				"description" : ""
			},
			{
				"name" : "Duration",
				"data_type" : "uint8",
				"units" : "s",
				"description" : "Duration spent in answering full survey"
			},
			{
				"name" : "Finished",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecordedDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time of survey being recorded (internal Qualtrics timing)"
			},
			{
				"name" : "ResponseId",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecipientLastName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient last name (not used)"
			},
			{
				"name" : "RecipientFirstName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient first name (not used)"
			},
			{
				"name" : "RecipientEmail",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient email address (not used)"
			},
			{
				"name" : "ExternalReference",
				"data_type" : "string",
				"units" : "",
				"description" : "External Data Reference (not used)"
			},
			{
				"name" : "LocationLatitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response latitude"
			},
			{
				"name" : "LocationLongitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response longitude"
			},
			{
				"name" : "DistributionChannel",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "UserLanguage",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "Q1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please rate your current level of anxiety. - Point 0 (Pre-Drive)"
			},
			{
				"name" : "subject_number",
				"data_type" : "uint16",
				"units" : "",
				"description" : "Participant ID number"
			}]
		},
		{
			"name" : "/survey/drive_rp_9",
			"nickname" : "Survey / Anxiety Rating / Point 9",
			"ROS_data_type" : "",
			"collection_rate" : "",
			"description" : "[Survey key](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_AnxietyRatingPoint.pdf)",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "StartDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time start of survey (America/Denver timezone)"
			},
			{
				"name" : "EndDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time end of survey (America/Denver timezone)"
			},
			{
				"name" : "Status",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "IPAddress",
				"data_type" : "string",
				"units" : "",
				"description" : "IP address of respondent"
			},
			{
				"name" : "Progress",
				"data_type" : "uint8",
				"units" : "%",
				"description" : ""
			},
			{
				"name" : "Duration",
				"data_type" : "uint8",
				"units" : "s",
				"description" : "Duration spent in answering full survey"
			},
			{
				"name" : "Finished",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecordedDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time of survey being recorded (internal Qualtrics timing)"
			},
			{
				"name" : "ResponseId",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecipientLastName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient last name (not used)"
			},
			{
				"name" : "RecipientFirstName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient first name (not used)"
			},
			{
				"name" : "RecipientEmail",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient email address (not used)"
			},
			{
				"name" : "ExternalReference",
				"data_type" : "string",
				"units" : "",
				"description" : "External Data Reference (not used)"
			},
			{
				"name" : "LocationLatitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response latitude"
			},
			{
				"name" : "LocationLongitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response longitude"
			},
			{
				"name" : "DistributionChannel",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "UserLanguage",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "Q1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please rate your current level of anxiety. - Point 0 (Pre-Drive)"
			},
			{
				"name" : "subject_number",
				"data_type" : "uint16",
				"units" : "",
				"description" : "Participant ID number"
			}]
		},
		{
			"name" : "/survey/postdrive",
			"nickname" : "Survey / Post-Drive",
			"ROS_data_type" : "",
			"collection_rate" : "",
			"description" : "<br>[Survey key - Passenger](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_PostDrive.pdf)<br>[Survey key - Safety Driver](https://dsri-web-ms.iowa.uiowa.edu/ADSFRA/docs/survey/USDOT_ADS_PostDrive_-_Driver.pdf)",
			"collected_as" : "CSV",
			"data_table" : [{
				"name" : "StartDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time start of survey (America/Denver timezone)"
			},
			{
				"name" : "EndDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time end of survey (America/Denver timezone)"
			},
			{
				"name" : "Status",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "IPAddress",
				"data_type" : "string",
				"units" : "",
				"description" : "IP address of respondent"
			},
			{
				"name" : "Progress",
				"data_type" : "uint8",
				"units" : "%",
				"description" : ""
			},
			{
				"name" : "Duration",
				"data_type" : "uint8",
				"units" : "s",
				"description" : "Duration spent in answering full survey"
			},
			{
				"name" : "Finished",
				"data_type" : "uint8",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecordedDate",
				"data_type" : "string",
				"units" : "",
				"description" : "Date/time of survey being recorded (internal Qualtrics timing)"
			},
			{
				"name" : "ResponseId",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "RecipientLastName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient last name (not used)"
			},
			{
				"name" : "RecipientFirstName",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient first name (not used)"
			},
			{
				"name" : "RecipientEmail",
				"data_type" : "string",
				"units" : "",
				"description" : "Recipient email address (not used)"
			},
			{
				"name" : "ExternalReference",
				"data_type" : "string",
				"units" : "",
				"description" : "External Data Reference (not used)"
			},
			{
				"name" : "LocationLatitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response latitude"
			},
			{
				"name" : "LocationLongitude",
				"data_type" : "string",
				"units" : "",
				"description" : "Response longitude"
			},
			{
				"name" : "DistributionChannel",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "UserLanguage",
				"data_type" : "string",
				"units" : "",
				"description" : ""
			},
			{
				"name" : "Q3_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I believe that highly automated vehicles are reliable."
			},
			{
				"name" : "Q3_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I am suspicious of highly automated vehicles."
			},
			{
				"name" : "Q3_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I can trust highly automated vehicles."
			},
			{
				"name" : "Q3_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I believe that highly automated vehicles will work the way I expect them to."
			},
			{
				"name" : "Q4_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I am not worried about riding in a highly automated vehicle."
			},
			{
				"name" : "Q4_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I believe that highly automated vehicles might cause crashes."
			},
			{
				"name" : "Q4_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I believe that highly automated vehicles are safer than manually driven vehicles."
			},
			{
				"name" : "Q4_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I feel safe riding in a highly automated vehicle."
			},
			{
				"name" : "Q4_5",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I am afraid to ride in a highly automated vehicle."
			},
			{
				"name" : "Q4_6",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I believe highly automated vehicles are dangerous."
			},
			{
				"name" : "Q5_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive on the freeway/highway"
			},
			{
				"name" : "Q5_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive on city streets"
			},
			{
				"name" : "Q5_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive in congested traffic"
			},
			{
				"name" : "Q5_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive in residential areas"
			},
			{
				"name" : "Q5_5",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive in areas with lots of pedestrian traffic"
			},
			{
				"name" : "Q5_6",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive on gravel roads"
			},
			{
				"name" : "Q5_7",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - drive through construction zones"
			},
			{
				"name" : "Q6_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - navigate a parking lot and park itself"
			},
			{
				"name" : "Q6_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - operate in closed areas (e.g., airports, campuses, retirement villages)"
			},
			{
				"name" : "Q6_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - operate without a steering wheel or other controls"
			},
			{
				"name" : "Q6_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - maintain a safe following distance"
			},
			{
				"name" : "Q6_5",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - respond to traffic light/sign"
			},
			{
				"name" : "Q6_6",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - stay within the correct lane"
			},
			{
				"name" : "Q6_7",
				"data_type" : "uint8",
				"units" : "",
				"description" : "I would trust a highly automated vehicle to: - parallel park"
			},
			{
				"name" : "Q7_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How concerned are you about the following issues related to highly automated vehicles? - the safety consequences of equipment or system failure"
			},
			{
				"name" : "Q7_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How concerned are you about the following issues related to highly automated vehicles? - its ability to interact with non-self-driving vehicles"
			},
			{
				"name" : "Q7_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How concerned are you about the following issues related to highly automated vehicles? - its ability to interact with pedestrians and bicyclists"
			},
			{
				"name" : "Q7_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How concerned are you about the following issues related to highly automated vehicles? - system performance in poor weather"
			},
			{
				"name" : "Q7_5",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How concerned are you about the following issues related to highly automated vehicles? - the system being confused by unexpected situations"
			},
			{
				"name" : "Q7_6",
				"data_type" : "uint8",
				"units" : "",
				"description" : "How concerned are you about the following issues related to highly automated vehicles? - the system not driving as well as human drivers"
			},
			{
				"name" : "Q8_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - I am open to the idea of riding in a highly automated vehicle."
			},
			{
				"name" : "Q8_2",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - Highly automated vehicles will allow me to stay active."
			},
			{
				"name" : "Q8_3",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - Highly automated vehicles will allow me to stay involved in my community."
			},
			{
				"name" : "Q8_4",
				"data_type" : "uint8",
				"units" : "",
				"description" : "Please indicate how you currently feel about each one of the statements. - Highly automated vehicles will enhance my quality of life/well-being."
			},
			{
				"name" : "Q9_1",
				"data_type" : "uint8",
				"units" : "",
				"description" : "What percentage of the drive do you think the vehicle was in AUTOMATED mode (only being monitored by the researcher in the driver's seat)? - Click to write Choice 1"
			},
			{
				"name" : "subject_number",
				"data_type" : "uint16",
				"units" : "",
				"description" : "Participant ID number"
			}]
		}
	]
}
`)

export default dictionary_data
